import React, {
  useState,
  useEffect,
  useRef,
  memo,
  FC,
  Dispatch,
  SetStateAction,
} from "react";
import {
  HStack,
  VStack,
  Box,
  Button,
  Text,
  Pressable,
  Image,
  Divider,
  Tooltip,
  Spinner,
  Input,
  Collapse,
  IconButton,
  ScrollView,
} from "native-base";
import _ from "lodash";
import {
  MoreHorizontalIcon,
  FavouriteIcon,
  AddIcon,
  MinusIcon,
  GroupChatIcon,
  FacebookIcon,
  InstagramIcon,
  ShapeContectIcon,
  LivestreamIcon,
  ArrowActiveIcon,
  ArrowInActiveIcon,
} from "../../assets/icons/icon-assets";
import AVHeaderTitle from "./AVHeaderTitle";
import AVCoverPic from "./AVCoverPic";
import AVProfilePic from "./AVProfilePic";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import * as AV from "../../AVCore/AVCore";
import {
  setUser,
  setSearch,
  setEntitydata,
} from "../../Redux/Actions/userActions";
import {
  setShowLiveHostModal,
  setLiveEntity,
} from "../../Redux/Actions/liveStreamActions";
import { useNavigate } from "react-router-dom";
import { Loc } from "../../App/Loc";
import Moment from "moment";
import { Dimensions } from "react-native";
import Dropdown from "../../assets/images/Drop.png";
import { useLocation, useParams } from "react-router-dom";
import Deleted from "../../assets/images/Deleted.png";
import { setConvo } from "../../Redux/Actions/convoActions";
import useConvoChat from "../../Hooks/useConvoChat";
import CustomToast from "../../Hooks/useCustomToast";
import { Server } from "../../Platform/Server";
import AVCancel from "../../components/common/AVCancel";
import AVInputtext from "../../components/AVInputtext";
import { CloseIcon, SearchIcon } from "native-base";
import EntityProfilePic from "../../components/common/EntityProfilePic";
import { AVChatMessage } from "../../components/common/EntityTabs/AVChatMessage";

declare function appendHelcimPayIframe(
  checkoutToken: string,
  showImmediately: boolean,
): void;

interface PaymentMessageData {
  hash: string;
  data: {
    amount: number | string;
    [key: string]: unknown;
  };
}

interface PaymentData {
  checkoutToken: string;
  data: PaymentMessageData;
}

type ExtendedEntity = AV.IAVEntity & {
  teams?: AV.ITypeLink[];
};

const ProfileHeader = ({
  props,
  setIshuddleData,
  isCreate,
  isCreateDependents,
  setIsCreateDependents,
  isDeleted,
  isShowEdit,
  Entity,
  setEntity,
  EntityType,
  type,
  leagueGameEntity,
  setLeagueGameEntity,
  handleUpload,
  setIsShowEdit,
  profile,
  setProfile,
  googlemap,
  isAdminView,
  setIsAdminView,
  setIsStaffReq,
  setIsChildOrgReq,
  weatherURL,
  weather,
  Owner,
  setIsImagePopup,
  editAccess,
  HandleBlockUser,
  HandleUnBlockUser,
  HandleRestoreAccount,
  setIsConvoData,
  HandleUnFollowUser,
  setIsOpenConvo,
  setIsEditEntireSeries,
  isEditEntireSeries,
  seriesEvent,
  isRequestAgain,
  setIsRequestAgain,
  openPreview,
  isShowPayPopup,
  setIsShowPayPopup,
  setClickedUrl,
  setShowConfirmLinkPopup,
  //isShowAddGuestTeam,
  //setIsShowAddGuestTeam,
  //guestTeamName,
  //setGuestTeamName,
  //guestTeamLocation,
  //setGuestTeamLocation,
  isEntireSeriesAvailable = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();
  const params = useParams();
  let userconvo: any = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 600 || false;
  const data = location?.state?.user;
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const isOnline = useSelector((state: RootStateOrAny) => state.user.isOnline);
  const [isMyFavourite, setMyFavourite] = useState(false);
  const [isFavLoader, setIsFavLoader] = useState(false);
  var target: any = AV.AVEntity.getFk(Entity);
  const [isFollowing, setIsFollowing] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [followRequestSending, setFollowRequestSending] = useState(false);
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const localUserSearch = useSelector(
    (state: RootStateOrAny) => state.user.userSearch,
  );
  const lastScoreUpdate = useSelector(
    (state: RootStateOrAny) => state?.alerts?.lastScore,
  );
  const pathName = window.location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const [isShowEditOccurence, setIsShowEditOccurence] = useState(false);
  const [isShowEditEntireSeries, setIsShowEditEntireSeries] = useState(false);
  let seriesEventData = Entity?.seriesEvents?.filter(
    (x) => x.id == params?.seriesId,
  )[0];
  const [isUpdateRSVPStatus, setIsUpdateRSVPStatus] = useState("");
  const [participantstatus, setParticipantStatus] = useState(
    seriesEventData?.participants &&
      seriesEventData?.participants[0]?.status?.trim()?.length > 0
      ? seriesEventData?.participants[0]?.status
      : !seriesEventData?.participants &&
          Entity?.participants
            ?.filter((x) => x.id === currentUser?.id)[0]
            ?.status?.trim()?.length > 0
        ? Entity?.participants?.filter((x) => x.id === currentUser?.id)[0]
            ?.status
        : "RSVP",
  );
  const [playersList, setPlayersList] = useState<any>([]);
  const [isActives, setIsActives] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const userID = params?.userId;
  const region = params?.region;
  const [isBlockLoad, setIsBlockLoad] = useState<any>(false);
  const participantUser = Entity?.participants?.filter(
    (x) => x.id === currentUser?.id,
  );
  const [isShowPicker, setIsShowpicker] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const { handleGetGroupConvo, handleSendSingleChat } = useConvoChat();
  const [isLoad, setisLoad] = useState(false);
  const isMemberOfEntity = Entity?.members?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isPlayerOfEntity = Entity?.players?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isstaffOfEntity = Entity?.staff?.some((x) => x?.id === currentUser?.id);
  const [openMenu, setOpenMenu] = useState(false);
  const [isRsvpLoading, setIsRsvpLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [payAmount, setPayAmount] = useState("");
  const [remainingAmount, setRemainingAmount] = useState<number>(0);
  const [pageLoader, setPageLoader] = useState(false);
  const [isLoadingPay, setIsLoadingPay] = useState(false);
  const [isCollectFullyPaid, setIsCollectFullyPaid] = useState(false);

  // Game
  const [isShowAddGuestTeam, setIsShowAddGuestTeam] = useState(false);
  const [guestTeamLocation, setGuestTeamLocation] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [suggestions, setSuggestions] = useState<AV.ILink[]>([]);
  const [searchResults, setSearchResults] = useState<AV.ILink[]>([]);
  const [selectedOrgs, setSelectedOrgs] = useState<AV.ILink[]>([]);

  const [showGameInfo, setShowGameInfo] = useState(false);
  const [showScoreInfo, setShowScoreInfo] = useState(false);
  const [homeTeam, setHomeTeam] = useState<ExtendedEntity>();
  const [guestTeam, setGuestTeam] = useState<ExtendedEntity>();
  const [showPeriodMenu, setShowPeriodMenu] = useState(false);

  // Search Game Guest Team
  const handleSearchItems = async (searchValue: string) => {
    setSearchQuery(searchValue);

    if (searchValue.length >= 1) {
      try {
        // Get search results from AV.Person.search
        const searchLocalData = await AV.Person.localSearch(searchValue);
        const searchGlobalData: AV.ILink[] = await AV.Person.search(
          searchValue,
          "Org",
        );
        const searchData = [
          ...(searchLocalData || []),
          ...(searchGlobalData || []),
        ];
        let results = (searchData || []) as AV.ILink[];
        const query = searchValue.toLowerCase();

        // Filter and transform the results
        results = results.filter(
          (x) =>
            x?.title !== undefined &&
            x?.data !== "Deleted" &&
            x?.data !== "Suspended" &&
            x?.type === "PlayerOrg" &&
            (x?.title?.toLowerCase().includes(query) ||
              x?.data?.toLowerCase().includes(query)),
        );

        // Include dependents (wards)
        const wardMatches =
          currentUser?.wards?.filter(
            (x) =>
              x?.title &&
              (x.title.toLowerCase().includes(query) ||
                x.data?.toLowerCase().includes(query)),
          ) ?? [];

        results = results.concat(wardMatches);

        // Remove blocked users and channels
        results = results.filter(
          (x) => !currentUser?.blocked?.some((y: AV.ILink) => y?.id === x?.id),
        );

        //// Remove already shared orgs
        //results = results.filter(
        //  (x) => !sharedPlan?.shared?.some((y: AV.ILink) => y?.id === x?.id),
        //);

        // Remove already selected orgs
        results = results.filter(
          (x) => !selectedOrgs?.some((y: AV.ILink) => y?.id === x?.id),
        );

        // Remove duplicates and format for display
        const formattedResults = _.uniqBy(results, "id");

        setSearchResults(formattedResults);
        setSuggestions(formattedResults);

        let locSearch = localUserSearch;
        if (locSearch == undefined) locSearch = [];
        locSearch = locSearch.concat(results);
        locSearch = locSearch?.filter(
          (x) => !currentUser?.blocked?.some((y) => y?.id === x?.id),
        );
        locSearch = _.uniqBy(locSearch, "id");
        dispatch(setSearch(locSearch));
      } catch (error) {
        console.error("Error searching orgs:", error);
        setSearchResults([]);
        setSuggestions([]);
      }
    } else {
      setSearchResults([]);
      setSuggestions([]);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setSuggestions([]);
    setSearchResults([]);
    setSelectedOrgs([]);
    setIsSearching(false);
  };

  const handleOrgSelect = async (org: AV.ILink) => {
    setSelectedOrgs([]);
    let entity = entitydatalist?.find((x) => x?.id === org?.id) ?? null;

    if (!entity) {
      entity = await AV.AVEntity.get(org);
      entitydatalist?.push(entity);
      dispatch(setEntitydata(entitydatalist));
    }

    //if (entity?.plan?.shared) {
    //  let clientError = {
    //    message: Loc.currentLang.myPlan.alreadySharedError,
    //  };
    //  CustomToast({ clientError });

    //  return;
    //}

    setSelectedOrgs((prevOrgs) => {
      // Avoid duplicates
      if (prevOrgs.some((o) => o.id === org.id)) {
        return prevOrgs;
      }
      return [...prevOrgs, org];
    });

    setSearchQuery("");
    setSuggestions([]);
    setSearchResults([]);
  };

  const handleRemoveOrg = (orgId: string) => {
    setSelectedOrgs(selectedOrgs.filter((o) => o.id !== orgId));
  };

  //Follow and Unfollow
  const handleFollowProfile = async (type, name) => {
    var targetFK: any = AV.Person.getLink(Entity);
    targetFK.linkType = "Follow";
    switch (type) {
      case "follow":
        setFollowRequestSending(true);
        let result: any = await AV.Person.makeRequest(
          AV.Person.getLink(currentUser),
          targetFK,
        );
        if (result) {
          dispatch(setUser(result));
          if (result.follows.filter((x) => x.id === targetFK.id).length > 0) {
            setIsFollowing(true);
          } else {
            setRequestSent(true);
          }
        }
        setFollowRequestSending(false);
        break;
      case "unfollow":
        HandleUnFollowUser(AV.AVEntity.getFk(Entity), name);
        //setIsFollowing(false);
        setRequestSent(false);
        setFollowRequestSending(false);
        break;
    }
  };

  //Add and Remove Favourite
  const handleFavourite = async (type) => {
    setIsFavLoader(true);
    if (currentUser?.favs?.length >= 100) {
      let clientError = { message: "Favourite limit exceeds" };
      CustomToast({ clientError });
      setIsFavLoader(false);
      return;
    }

    let resp =
      type === "addFavourite"
        ? await AV.Person.addFavorite(
            AV.AVBase.getFk(currentUser),
            AV.AVEntity.getLink(Entity),
          ).then((x) => {
            dispatch(setUser(x));
          })
        : type === "removeFavourite"
          ? await AV.Person.removeFavorite(
              AV.AVBase.getFk(currentUser),
              AV.AVEntity.getLink(Entity),
            ).then((x) => {
              dispatch(setUser(x));
            })
          : "";
    type === "addFavourite" ? setMyFavourite(true) : setMyFavourite(false);
    setIsFavLoader(false);
  };

  const findPersonInChats = (conversations, personToCheck) => {
    return conversations?.find(
      (convo) =>
        convo?.subject === "" &&
        convo?.people?.some(
          (person) =>
            person?.id === personToCheck?.id &&
            person?.pk === personToCheck?.pk,
        ),
    );
  };

  const handleChat = async (item: any) => {
    setisLoad(true);
    let People: any = [];
    var sourceFK: any = AV.AVEntity.getLink(item);
    sourceFK.title = item?.name;
    People?.push(sourceFK);
    let valid = await findPersonInChats(userconvo, item);

    if (valid?.id !== undefined) {
      setIsConvoData(valid?.id);
      setisLoad(false);
      setIsOpenConvo(true);
      return;
    }

    let chatData = await handleSendSingleChat(People);
    if (chatData) {
      setIsConvoData(chatData?.id);
    }
    setisLoad(false);
    setIsOpenConvo(true);
  };

  const HandleGroupChat = async (type) => {
    setisLoad(true);
    if (Entity?.type == "Person") {
      handleChat(Entity);
      return;
    }

    if (!Entity?.leagueGame) {
      let valid =
        type == "W" ? Entity.wConvo : type == "A" ? Entity?.aConvo : "";

      const isForceAllGroup =
        (Entity?.type === "PlayerOrg" &&
          Entity?.parent?.type === "Team" &&
          Entity?.subType === undefined) ||
        Entity?.type === "SchoolYear" ||
        ["Term", "Class", "GradClass", "MusicGroup"].includes(Entity?.subType);

      if (isForceAllGroup) {
        type = "A";
        valid = Entity?.aConvo;
      } else if (Entity?.subType === "Alumni") {
        type = "S";
        valid = Entity?.sConvo;
      }

      if (valid?.trim()?.length > 0 ? true : false) {
        //setIsConvoData( valid )
        let HuddleData: any = currentUser?.orgs?.filter((x) => x?.id == valid);
        navigate(`/huddles/${HuddleData[0]?.id ?? 1}`, {
          state: { HuddleData: HuddleData[0] },
        });
        return;
      }

      if (valid === "" || valid == undefined) {
        let Response: any = await AV.AVEntity.CreateGroupConvo(target, type);
        console.log("Response", Response);
        let Index = entitydatalist?.findIndex((x) => x?.id == Response?.id);
        if (Index !== -1) {
          entitydatalist[Index] = Response;
          setEntity(Response);
        }

        dispatch(setEntitydata(entitydatalist));
        const fk: any = {
          id:
            type == "W" ? Response.wConvo : type == "A" ? Response?.aConvo : "",
          pk:
            type == "W" ? Response.wConvo : type == "A" ? Response?.aConvo : "",
          region: Entity?.region,
          type: "GroupConvo",
        };

        setIsConvoData(fk?.id);
        let person = await AV.Person.getSelf(true);
        dispatch(setUser(person));

        setTimeout(() => {
          let HuddleData: any = person?.orgs?.filter((x) => x?.id == fk.id);
          navigate(`/huddles/${HuddleData[0]?.id ?? 1}`, {
            state: { HuddleData: HuddleData[0] },
          });
          setIshuddleData(HuddleData[0]);
        }, 1000);
      }
      setisLoad(false);
      //setIsOpenConvo(true);
    } else if (Entity?.leagueGame) {
      let Response: any = await AV.AVEntity.CreateGroupConvo(
        Entity?.leagueGame,
        "N",
      );
      console.log("Response", Response);
    }
  };

  //RSVP function
  const handleUpdateParticipant = async (participantStatus, isEntireSeries) => {
    setIsRsvpLoading(true);
    if (participantStatus == "Yes") {
      setParticipantStatus(Loc.currentLang.menu.attending);
    } else if (participantStatus == "No") {
      setParticipantStatus(Loc.currentLang.menu.notAttending);
    } else if (participantStatus == "Maybe") {
      setParticipantStatus(Loc.currentLang.menu.mayBe);
    }

    //setIsActives(!isActives);
    setParticipantStatus(participantStatus);
    //let occurId = Entity.series && !isEditEntireSeries ? Entity.id != Entity.series ? Entity.id : null : null;
    //let isSeries = isEditEntireSeries ? null : seriesEventData?.id;
    let isSeries = isEntireSeries ? null : seriesEventData?.id;
    //Entity.id = Entity.series ? Entity.series : Entity.id;
    setIsUpdateRSVPStatus("");
    await AV.Event.updateParticipant(
      AV.AVEntity.getFk(Entity),
      { ...AV.AVEntity.getLink(currentUser), status: participantStatus },
      isSeries,
    ).then(async (e: any) => {
      if (e) {
        let statusevent = e?.participants?.filter(
          (x) => x?.id === currentUser?.id,
        );
        if (statusevent?.length > 0)
          setParticipantStatus(
            statusevent[0]?.status ? statusevent[0]?.status : "RSVP",
          );
        setEntity(e);
        setPlayersList(e?.participants);
        let oldvalue = currentUser.events.filter((a) => a.id == e?.id);
        e.status = statusevent[0]?.status ? statusevent[0]?.status : "RSVP";
        currentUser.events[currentUser.events.indexOf(oldvalue[0])] = e;
        entitydatalist[
          entitydatalist.indexOf(entitydatalist?.find((x) => x?.id === e?.id))
        ] = e;
        dispatch(setEntitydata(entitydatalist));
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        setTimeout(() => {
          navigate(`/Events/${e?.id}/${e?.region}/${seriesEventData?.id}`, {
            state: { team: e, newEntity: true },
          });
        }, 300);
      } else {
        Entity.status = participantStatus;
        Entity.participants = Entity.participants.map((event) => ({
          ...event,
          status: participantStatus,
        }));
        setEntity(Entity);
        setPlayersList(Entity?.participants);
        //setEventData(e);
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === Entity?.id),
          )
        ] = Entity;
        dispatch(setEntitydata(entitydatalist));
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        setTimeout(() => {
          navigate(`/Events/${Entity?.id}/${Entity?.region}/${e?.seriesId}`, {
            state: { team: Entity },
          });
        }, 300);
      }
    });
    setIsRsvpLoading(false);
  };

  const menuRef = useRef(null);
  useOutsideAlerter(menuRef);

  //Hook that alerts clicks outside of the passed ref
  function useOutsideAlerter(ref) {
    useEffect(() => {
      // Alert if clicked on outside of element
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActives(false);
          setIsOpen(false);
          setOpenMenu(false);
          setIsShowEditOccurence(false);
          setIsShowEditEntireSeries(false);
          setIsUpdateRSVPStatus("");
          setShowPeriodMenu(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", (event) => {
        setTimeout(() => handleClickOutside(event), 0);
      });
      return () => {
        // Unbind the event listener on clean up
        document.addEventListener("mousedown", (event) => {
          setTimeout(() => handleClickOutside(event), 0);
        });
      };
    }, [ref]);
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      //if (seriesEventData) {
      //  seriesEvent.location = seriesEventData?.location ? seriesEventData?.location : Entity?.location;
      //}
      const following = currentUser?.follows?.filter(
        (item) => item?.id === Entity?.id,
      );
      const requests = currentUser?.myRequests?.filter(
        (item) => item?.target?.id === Entity?.id && item?.type === "Follow",
      );
      const Blocked = currentUser?.blocked;
      following?.length > 0 ? setIsFollowing(true) : setIsFollowing(false);
      requests?.length > 0 ? setRequestSent(true) : setRequestSent(false);
      if (currentUser?.favs?.filter((x) => x?.id === Entity?.id)[0]) {
        setMyFavourite(true);
      } else {
        setMyFavourite(false);
      }

      Blocked?.filter((item) => item?.id === Entity?.id).length > 0
        ? setIsBlock(true)
        : setIsBlock(false);

      // Pet Present
      if (Entity?.type === "Pet") {
        setIsFollowing(
          currentUser?.wards?.some(
            (item) => item?.id === Entity?.id && Entity?.type === "Pet",
          ) || following?.length > 0,
        );
      }

      if (Entity?.type === "Collect") {
        const userParticipant = Entity?.participants?.find(
          (x) => x?.id === currentUser?.id,
        );

        if (userParticipant) {
          const isPaid = userParticipant?.amount === Entity?.goal;
          setIsCollectFullyPaid(!!isPaid);

          const remaining =
            (userParticipant?.goalAmount ?? 0) - (userParticipant?.amount ?? 0);
          setRemainingAmount(Math.max(remaining, 0));
          setPayAmount(String(Math.max(remaining, 0)));
        } else {
          setPayAmount("0");
          setRemainingAmount(0);
          setIsCollectFullyPaid(true);
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [Entity, currentUser]);

  const getEntity = async (entityFK, activity = "") => {
    if (!entityFK?.id) return null;

    let entity = entitydatalist?.find((x) => x?.id === entityFK?.id) ?? null;

    if (!entity) {
      let entityAPI: AV.IAVEntity | null = null;

      if (entityFK.type === "LeagueGameBase") {
        const param: AV.ILeagueGameParam = {
          source: entityFK,
          scoreType: activity,
        };
        entityAPI = await AV.Game.getLeagueGame(param);
      } else {
        entityAPI = await AV.AVEntity.get(entityFK);
      }

      if (entityAPI) {
        const updatedEntityData = [...(entitydatalist || []), entityAPI];
        dispatch(setEntitydata(updatedEntityData));
        entity = entityAPI;
      }
    }

    return entity;
  };

  useEffect(() => {
    let isMounted = true;

    const fetchLeagueGame = async () => {
      if (!isMounted) return;

      if (Entity?.type === "Game") {
        const leagueGame = await getEntity(
          Entity?.leagueGame,
          Entity?.scoreType,
        );

        const homeTeamFK = leagueGame?.teams?.find(
          (x) => x?.id === Entity?.parent?.id,
        );

        const guestTeamFK = leagueGame?.teams?.find(
          (x) => x?.id !== Entity?.parent?.id,
        );

        const homeTeam = await getEntity(homeTeamFK);
        const guestTeam = await getEntity(guestTeamFK);

        if (isMounted) {
          setLeagueGameEntity?.(leagueGame);
          setHomeTeam(homeTeam);
          setGuestTeam(guestTeam ?? guestTeamFK);
        }
      }
    };

    fetchLeagueGame();

    return () => {
      isMounted = false;
    };
  }, [Entity, currentUser, leagueGameEntity]);

  useEffect(() => {
    console.log("last score update", lastScoreUpdate);
    if (
      !lastScoreUpdate ||
      !leagueGameEntity?.id ||
      Entity?.id !== lastScoreUpdate?.target?.id
    )
      return;
    //if (lastScoreUpdate?.target?.id !== Entity?.id || isAdminView) return;

    const scoreData = lastScoreUpdate?.data?.score
      ? JSON.parse(lastScoreUpdate.data.score)
      : null;

    setLeagueGameEntity((prev) => {
      if (!prev) return prev;

      if (
        lastScoreUpdate?.alertType === "StartGame" ||
        lastScoreUpdate?.alertType === "FinishGame"
      ) {
        return {
          ...prev,
          status: lastScoreUpdate?.data?.status,
        };
      }

      if (
        lastScoreUpdate?.alertType === "UpdateScore" &&
        lastScoreUpdate?.data?.action === "DeleteScore"
      ) {
        const newScoreHistory = (prev?.scoreHistory || []).filter(
          (x) => x?.id !== scoreData?.id,
        );

        return {
          ...prev,
          scoreHistory: newScoreHistory,
          score: newScoreHistory?.[newScoreHistory.length - 1] || null,
        };
      }

      if (
        lastScoreUpdate?.alertType === "UpdateScore" &&
        lastScoreUpdate?.data?.action === "AddScore"
      ) {
        const alreadyExists =
          prev?.scoreHistory?.some(
            (x) =>
              x?.id ===
              scoreData?.id /* || x?.gameClock === scoreData?.gameClock*/,
          ) ?? false;

        return {
          ...prev,

          // latest score
          score: scoreData,

          // history
          scoreHistory: alreadyExists
            ? prev?.scoreHistory || []
            : [...(prev?.scoreHistory || []), scoreData],
        };
      }
    });
  }, [lastScoreUpdate]);

  // sub components
  const RenderRsvp = ({ entity }: { entity: any }) => {
    const params: any = useParams();

    let isEventOwner = true;
    let participantStatus = "";
    const entireParticipant =
      entity?.participants?.find((p) => p?.id === currentUser?.id) || null;
    seriesEventData =
      entity?.seriesEvents?.find((p) => p?.id === params.seriesId) || null;
    let isOccEvent = !(
      entity?.eventType === "Show" ||
      entity?.eventType === "Social" ||
      entity?.eventType === "Game" ||
      ((entity?.eventType === "Meeting" || entity?.eventType === "Practice") &&
        entity?.seriesEvents?.length === 0)
    );

    let occParticipant: AV.ITypeLink | null = null;
    if (isOccEvent) {
      occParticipant =
        seriesEventData?.participants?.find((p) => p?.id === currentUser?.id) ||
        null;
      participantStatus =
        seriesEventData?.status ||
        occParticipant?.status ||
        entireParticipant?.status ||
        null;
      isEventOwner =
        entireParticipant?.linkType === "Owner" ||
        entireParticipant?.linkType === "Staff" ||
        occParticipant?.linkType === "Owner" ||
        occParticipant?.linkType === "Staff";
    } else {
      participantStatus = entireParticipant?.status || null;
      isEventOwner =
        entireParticipant?.linkType === "Owner" ||
        entireParticipant?.linkType === "Staff";
    }

    let isCanceled = entity?.status
      ? entity?.status === "Canceled"
        ? true
        : participantStatus
          ? participantStatus === "Canceled"
          : false
      : false;

    let isParticipantPercent = !!(entireParticipant?.id || occParticipant?.id);

    const handleUncancelEvent = async () => {
      try {
        setIsLoader(true);

        if (
          Entity?.status !== "Canceled" &&
          params?.seriesId !== "undefined" &&
          params?.seriesId !== undefined &&
          params?.seriesId
        ) {
          let fk = {
            id: Entity.series,
            pk: Entity.series.slice(-4),
            region: Entity.region,
            type: Entity.type,
          };
          await AV.Event.unCancelSeries(fk, params?.seriesId);
          // Find the index of the target entity in the entitydatalist
          const entityIndex = entitydatalist?.findIndex(
            (x) => x?.id === Entity?.id,
          );

          // Check if the entity exists
          if (entityIndex !== -1) {
            // Get the specific entity
            const event = entitydatalist[entityIndex];

            // Find the index of the specific seriesEvent within the event
            const seriesEventIndex = event.seriesEvents.findIndex(
              (se) => se?.id === params?.seriesId,
            );

            // If the seriesEvent is found, update its status
            if (seriesEventIndex !== -1) {
              // Update the seriesEvent's status
              event.seriesEvents[seriesEventIndex] = {
                ...event.seriesEvents[seriesEventIndex],
                status: "",
              };

              // Update the entity in the entitydatalist
              const updatedEntitydatalist = [...entitydatalist];
              updatedEntitydatalist[entityIndex] = event;
              setEntity(event);
              // Dispatch the updated entitydatalist
              dispatch(setEntitydata(updatedEntitydatalist));
              navigate(
                `/Events/${Entity?.id}/${Entity?.region}/${params?.seriesId}`,
                { state: { team: Entity } },
              );
            }
          }

          setEntity(Entity);
          setIsLoader(false);
          setIsShowEdit(false);
        } else {
          // Entity.id = Entity.series ? Entity.series : Entity.id;
          await AV.Event.unCancelEvent(AV.AVEntity.getFk(Entity));
          Entity.status = null;
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x) => x?.id === Entity?.id),
            )
          ] = Entity;

          let data: any = currentUser.events?.filter(
            (x) => x?.id == Entity?.id,
          );
          if (data) {
            data[0].status = null;
            data[0].data = null;
            let finalUser = await AV.Person.getSelf(true);
            dispatch(setUser(finalUser));
          }

          dispatch(setEntitydata(entitydatalist));
          setIsLoader(false);
          setIsShowEdit(false);
          navigate(
            `/Events/${Entity?.id}/${Entity?.region}/${params?.seriesId}`,
            { state: { team: Entity } },
          );
        }
      } catch (e) {
        console.log("Error in Un-cancel Event", e);
      } finally {
        setIsLoader(false);
      }
    };

    return (
      <>
        <HStack space={2} alignItems="center">
          {/* Canceled Label */}
          {isCanceled && (
            <HStack alignSelf={"center"} space={2}>
              <Text color={"red.500"} fontSize={"18px"} fontWeight={500}>
                {Loc.currentLang.menu.canceled
                  ? Loc.currentLang.menu.canceled
                  : "Canceled"}
              </Text>
            </HStack>
          )}

          {/* GAME INFO TOGGLE */}
          {(leagueGameEntity?.status === "Started" ||
            leagueGameEntity?.status === "Ended") && (
            <Pressable
              onPress={() => {
                setShowGameInfo((p) => !p);
                setShowScoreInfo((p) => !p);
              }}
              height="40px"
              px="20px"
              bg="#E5DFDF"
              borderRadius="20px"
              alignItems="center"
              justifyContent="center"
              _hover={{
                bg: "#E5DFDF",
              }}
            >
              <HStack alignItems="center" space="8px">
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  color="#374151"
                  lineHeight="20px"
                >
                  {leagueGameEntity?.status === "Ended"
                    ? `${Loc.currentLang.menu.viewFieldOrRoom} ${Loc.currentLang.menu.gameText}`
                    : Loc.currentLang.gameEvent.gameInfo}
                </Text>

                {showGameInfo || showScoreInfo ? (
                  <ArrowActiveIcon width="18" height="18" />
                ) : (
                  <ArrowInActiveIcon width="18" height="18" />
                )}
              </HStack>
            </Pressable>
          )}

          {/* Start/End Game */}
          {Entity?.type === "Game" &&
            leagueGameEntity?.status !== "Ended" &&
            isAdminView && (
              <Button
                minWidth="100px"
                right={
                  /*(leagueGameEntity?.teams?.length ?? 0) > 1 ? "42%" : */ "0%"
                }
                bgColor={
                  leagueGameEntity?.status === "Started" ? "#E13D3C" : "#32AE78"
                }
                rounded="full"
                fontWeight="550px"
                color="#fff"
                p={2}
                height="40px"
                borderRadius="20px"
                isLoading={isLoader}
                isDisabled={
                  leagueGameEntity?.status !== "Started"
                    ? (!editAccess && !isEntireSeriesAvailable) ||
                      !isParticipantPercent
                    : false
                }
                borderColor="AVColor.primary"
                onPress={() => {
                  if (leagueGameEntity?.status !== "Started") {
                    if ((leagueGameEntity?.teams?.length ?? 0) > 1) {
                      handleStartGame();
                    } else {
                      handleStartGameFromGame();
                    }
                  } else {
                    handleEndGame();
                  }
                }}
              >
                <Text color="white" fontWeight="medium">
                  {leagueGameEntity?.status !== "Started"
                    ? Loc.currentLang.gameEvent.startGame
                    : Loc.currentLang.gameEvent.endGame}
                </Text>
              </Button>
            )}

          {/* Restore Event */}
          {isCanceled &&
            (isAdminView || isEventOwner) &&
            (editAccess || isEntireSeriesAvailable) && (
              <Button
                minWidth="100px"
                marginLeft={"15px"}
                bgColor="#32AE78"
                rounded="full"
                fontWeight="550px"
                color="#fff"
                p={2}
                height="40px"
                borderRadius="20px"
                isLoading={isLoader}
                borderColor="AVColor.primary"
                onPress={handleUncancelEvent}
                disabled={!editAccess && !isEntireSeriesAvailable}
              >
                <Text color="white" fontWeight="medium">
                  {Loc.currentLang.menu.restoreEvent}
                </Text>
              </Button>
            )}

          {/* RSVP */}
          {!isCanceled && leagueGameEntity?.status !== "Started" && (
            <HStack ref={menuRef}>
              <Button
                minWidth="100px"
                bgColor="#32AE78"
                rounded="full"
                fontWeight="550px"
                color="#fff"
                p={2}
                justifyContent="flex-start"
                height="40px"
                borderRadius="20px"
                isLoading={isRsvpLoading}
                borderColor="AVColor.primary"
                onPress={() => setIsActives(!isActives)}
                isDisabled={
                  (!editAccess && !isEntireSeriesAvailable) ||
                  !isParticipantPercent
                }
              >
                <Text
                  color="white"
                  lineHeight="2rem"
                  paddingLeft="13px"
                  maxW={["130px"]}
                  text-overflow="ellipsis"
                  numberOfLines={1}
                  fontWeight={500}
                  fontSize="16px"
                >
                  {participantStatus
                    ? participantStatus === "Yes"
                      ? Loc.currentLang.menu.attending
                      : participantStatus === "No"
                        ? Loc.currentLang.menu.notAttending
                        : Loc.currentLang.menu.mayBe
                    : Loc.currentLang.menu.rsvp}
                </Text>
              </Button>

              {!isRsvpLoading && (
                <Pressable
                  position="absolute"
                  top="12px"
                  right="10px"
                  onPress={() => setIsActives(!isActives)}
                  disabled={
                    (!editAccess && !isEntireSeriesAvailable) ||
                    !isParticipantPercent
                  }
                >
                  <Image source={Dropdown} alt="Actavivo" size="15px" />
                </Pressable>
              )}
            </HStack>
          )}

          {/* RSVP Options */}
          <HStack>
            {isActives && (
              <HStack
                ref={menuRef}
                position="absolute"
                top={5}
                right={0}
                flexDirection="column"
                width="120px"
                left="-112px"
                borderRadius="5px"
                bgColor="#FFFFFF"
                shadow="9"
                rounded="lg"
                zIndex={999}
              >
                <Button
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("Yes", true);
                    }
                    setIsUpdateRSVPStatus("Yes");
                    setIsActives(!isActives);
                  }}
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                >
                  <Text color="black">{Loc.currentLang.menu.attending}</Text>
                </Button>

                <Button
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("No", true);
                    }
                    setIsUpdateRSVPStatus("No");
                    setIsActives(!isActives);
                  }}
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                >
                  <Text color="black">{Loc.currentLang.menu.notAttending}</Text>
                </Button>

                <Button
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("Maybe", true);
                    }
                    setIsUpdateRSVPStatus("Maybe");
                    setIsActives(!isActives);
                  }}
                >
                  <Text color="black">{Loc.currentLang.menu.mayBe}</Text>
                </Button>
              </HStack>
            )}
          </HStack>

          {/* Host Live Icon */}
          {!isCanceled && isAdminView && (
            <Tooltip openDelay={500} label={"Live"}>
              <Button
                width={"40px"}
                height={"40px"}
                rounded={"full"}
                bgColor={"#32AE78"}
                p={0}
                isDisabled={
                  leagueGameEntity?.status !== "Started"
                    ? (!editAccess && !isEntireSeriesAvailable) ||
                      !isParticipantPercent
                    : false
                }
                onPress={() => {
                  dispatch(setShowLiveHostModal(true));
                  dispatch(setLiveEntity(Entity));
                }}
              >
                <LivestreamIcon />
              </Button>
            </Tooltip>
          )}

          {/* More Settings */}
          {!isCanceled &&
            isAdminView &&
            (!leagueGameEntity || leagueGameEntity?.status !== "Started") && (
              <Pressable
                width="40px"
                height="40px"
                alignItems="center"
                justifyContent="center"
                bg="gray.100"
                _hover={{ bg: "gray.50" }}
                rounded="full"
                onPress={(e) => {
                  e.stopPropagation();
                  setOpenMenu(!openMenu);
                }}
              >
                <MoreHorizontalIcon
                  size="24px"
                  color={"AVColor.primaryText"}
                  alignSelf={"center"}
                />
              </Pressable>
            )}

          {/* More Menu */}
          {openMenu && (
            <VStack
              ref={menuRef}
              width={"128x"}
              height="auto"
              shadow={2}
              background={"#FFFFFF"}
              position={"absolute"}
              top={8}
              right={0}
              zIndex={999}
              borderRadius={"6px"}
            >
              {(editAccess || isEntireSeriesAvailable) && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      setIsShowEdit(true);
                    }
                    setIsOpen(false);
                    setOpenMenu(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.edit}
                  </Text>
                </Pressable>
              )}

              {(editAccess || isEntireSeriesAvailable) && <Divider />}

              <Pressable
                ref={menuRef}
                width={"100%"}
                height={"36px"}
                paddingX={"10px"}
                alignItems={"flex-start"}
                justifyContent={"center"}
                onPress={() => {
                  Entity?.type == "Person" || Entity?.type == "Pet"
                    ? navigate(
                        `/accountsettings/${currentUser?.id}/${currentUser?.region}`,
                        {
                          state: {
                            page: "Home",
                          },
                        },
                      )
                    : navigate(
                        `/accountsettings/${Entity?.id}/${Entity?.region}`,
                        {
                          state: {
                            page: pathName,
                            Entity: Entity,
                          },
                        },
                      );
                }}
                _hover={{
                  backgroundColor: "gray.100",
                }}
              >
                <Text fontSize={"14px"} fontFamily={"Roboto"}>
                  {Loc.currentLang.menu.setting}
                </Text>
              </Pressable>
            </VStack>
          )}

          {/* This/Entire Options (RSVP & Edit) */}
          {(isShowEditOccurence || isShowEditEntireSeries) && (
            <VStack
              ref={menuRef}
              width={"128x"}
              height="auto"
              shadow={2}
              background={"#FFFFFF"}
              position={"absolute"}
              top={"30px"}
              zIndex={999}
              borderRadius={"6px"}
            >
              {isShowEditOccurence && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    setIsEditEntireSeries(false);
                    isUpdateRSVPStatus == "Yes"
                      ? handleUpdateParticipant("Yes", false)
                      : isUpdateRSVPStatus == "No"
                        ? handleUpdateParticipant("No", false)
                        : isUpdateRSVPStatus == "Maybe"
                          ? handleUpdateParticipant("Maybe", false)
                          : setIsShowEdit(true);
                    setIsOpen(false);

                    setIsShowEditOccurence(false);
                    setIsShowEditEntireSeries(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.thisOccurrence}
                  </Text>
                </Pressable>
              )}

              {isShowEditOccurence && <Divider />}

              {isShowEditEntireSeries && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    setIsEditEntireSeries(true);
                    isUpdateRSVPStatus == "Yes"
                      ? handleUpdateParticipant("Yes", true)
                      : isUpdateRSVPStatus == "No"
                        ? handleUpdateParticipant("No", true)
                        : isUpdateRSVPStatus == "Maybe"
                          ? handleUpdateParticipant("Maybe", true)
                          : setIsShowEdit(true);
                    setIsOpen(false);

                    setIsShowEditOccurence(false);
                    setIsShowEditEntireSeries(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.entireSeries}
                  </Text>
                </Pressable>
              )}
            </VStack>
          )}
        </HStack>
      </>
    );
  };

  const handleMatriculate = async () => {
    try {
      // Clone the current entity list from Redux
      const updatedList = [...entitydatalist];

      // Helper to update an entity inside the local list
      const updateEntityInList = (updatedEntity: any) => {
        const idx = updatedList.findIndex((x) => x?.id === updatedEntity?.id);
        if (idx !== -1) updatedList[idx] = updatedEntity;
      };

      // Find or fetch the parent entity (School)
      let parentEntity: any | undefined;
      const foundParent = entitydatalist?.find(
        (x) => x?.id === Entity?.parent?.id,
      );
      parentEntity =
        foundParent ?? (await AV.AVEntity.get(Entity?.parent as AV.IFK));

      if (!parentEntity) {
        console.error("Parent entity not found.");
        return;
      }

      // Find the Alumni entity under the parent
      const alumni = parentEntity.childOrgs?.find(
        (x) => x.subType === "Alumni",
      );

      if (!alumni) {
        console.error("Alumni entity not found under parent.");
        return;
      }

      //// Reparent the Grad Class to Alumni using Save API
      //let gradClassEntity: any = {
      //  ...Entity,
      //  parent: alumni,
      //};

      //gradClassEntity = await AV.AVEntity.save(gradClassEntity);

      // Remove the Grad Class from its old parent using RemoveChild API
      parentEntity = await AV.Team.removeSeason(
        AV.AVEntity.getFk(parentEntity),
        AV.AVEntity.getFk(Entity), //AV.AVEntity.getFk(gradClassEntity),
      );

      //// If Matriculate is triggered from SchoolYear - remove GradClass from that SchoolYear
      //let yearEntity: any | undefined;
      ////const foundYearEntity = entitydatalist?.find(
      ////  (x) => x.id === parentEntity?.parent?.id,
      ////);
      ////yearEntity =
      ////  foundYearEntity ?? (await AV.AVEntity.get(Entity?.parent as AV.IFK));

      //yearEntity = parentEntity?.childOrgs?.filter(x => x.type === "SchoolYear");

      //if (yearEntity?.length > 0) {
      //  const schoolYearEntity: any = await AV.Club.removeGradClassFromYear(
      //    AV.AVEntity.getFk(yearEntity[0]),
      //    AV.AVEntity.getFk(gradClassEntity),
      //  );

      //  // Update year entity in the list
      //  updateEntityInList(schoolYearEntity);
      //}

      // Add the Grad Class to Alumni’s childOrgs using AddChild API
      const alumniEntity = await AV.Club.addTeam(
        AV.AVEntity.getFk(alumni),
        AV.AVEntity.getFk(Entity),
      );

      // Update local entity list and Redux
      updateEntityInList(alumniEntity);
      updateEntityInList(parentEntity);
      //updateEntityInList(gradClassEntity);
      dispatch(setEntitydata(updatedList));
    } catch (error) {
      console.error("Error during matriculate action:", error);
    }
  };

  const handleAddGuestTeam = async () => {
    try {
      setIsLoader(true);

      if (!Entity.leagueGame) {
        const leagueGame = await AV.Game.createLeagueGame(
          AV.AVEntity.getFk(Entity),
        );
        console.log("League Game:", leagueGame);
        Entity.leagueGame = AV.AVEntity.getFk(leagueGame);

        let index = entitydatalist?.findIndex((x) => x?.id === Entity?.id);
        if (index !== -1) {
          entitydatalist[index] = Entity;
          dispatch(setEntitydata(entitydatalist));
        }
        setEntity(Entity);
      }

      const param: AV.ITypeLinkParam = {
        source: Entity?.leagueGame,
        target: selectedOrgs[0] as AV.ITypeLink,
        scoreType: Entity?.scoreType,
      };

      const updatedLeagueGame = await AV.Game.addTeam(param);
      console.log("Updated LeagueGame:", updatedLeagueGame);

      if (updatedLeagueGame) {
        setLeagueGameEntity?.(updatedLeagueGame);
        entitydatalist?.push(updatedLeagueGame);
        dispatch(setEntitydata(entitydatalist));
      }
    } catch (err) {
      console.error("Failed to add guest team:", err);
    } finally {
      clearSearch();
      setIsLoader(false);
      setIsShowAddGuestTeam(false);
    }
  };

  const handleStartGameFromGame = async () => {
    //const currentTime = Moment();
    //const gameStartTime = Moment(Entity?.start);

    //if (currentTime.isBefore(gameStartTime)) {
    //  const clientError = {
    //    message: Loc.currentLang.gameEvent.gameStartTimeValidation,
    //  };
    //  CustomToast({ clientError });

    //  return;
    //}

    try {
      setIsLoader(true);

      const buildTeamPayload = (team, otherName): AV.ITypeLink | null => {
        if (team === "others") {
          const id = Server.generateUUID();

          return {
            id,
            pk: id.slice(-4),
            region: Entity?.region,
            title: otherName,
            type: "Team",
          };
        }

        if (team) {
          return team ?? null;
        }
        return null;
      };

      const teamsPayload: AV.ITypeLink[] = [
        buildTeamPayload(Entity?.parent, Entity?.parent?.title),
        buildTeamPayload("others", "Other Team"),
      ].filter((x): x is AV.ITypeLink => Boolean(x));

      const param: AV.ILeagueGameParam = {
        source: AV.AVEntity.getFk(Entity),
        teams: teamsPayload,
        scoreType: Entity?.scoreType,
      };
      const leagueGame = await AV.Game.startGameFromGame(param);
      console.log("League Game:", leagueGame);

      Entity.leagueGame = AV.AVEntity.getFk(leagueGame);
      let index = entitydatalist?.findIndex((x) => x?.id === Entity?.id);
      if (index !== -1) {
        entitydatalist[index] = Entity;
        dispatch(setEntitydata(entitydatalist));
      }
      setEntity(Entity);

      //HandleGroupChat("N");

      navigate(`/Events/${Entity?.id}/${Entity?.region}/undefined`, {
        state: { isCreate: false, team: Entity },
      });
    } catch (err) {
      console.error("Failed to start game from game:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const handleStartGame = async () => {
    try {
      setIsLoader(true);

      if (Entity.leagueGame) {
        const param: AV.ILeagueGameParam = {
          source: Entity?.leagueGame,
          scoreType: Entity?.scoreType,
        };
        const updatedLeagueGame = await AV.Game.startGame(param);
        console.log("updated LeagueGame:", updatedLeagueGame);

        let index = entitydatalist?.findIndex(
          (x) => x?.id === Entity.leagueGame?.id,
        );
        if (index !== -1) {
          entitydatalist[index] = updatedLeagueGame;
          dispatch(setEntitydata(entitydatalist));
        }
        setLeagueGameEntity?.(updatedLeagueGame);

        navigate(`/Events/${Entity?.id}/${Entity?.region}/undefined`, {
          state: { isCreate: false, team: Entity },
        });
      }
    } catch (err) {
      console.error("Failed to start game:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const handleEndGame = async () => {
    try {
      setIsLoader(true);

      if (Entity.leagueGame) {
        const param: AV.ILeagueGameParam = {
          source: Entity?.leagueGame,
          scoreType: Entity?.scoreType,
        };
        const updatedLeagueGame = await AV.Game.finishGame(param);
        console.log("updated LeagueGame:", updatedLeagueGame);

        let index = entitydatalist?.findIndex(
          (x) => x?.id === Entity.leagueGame?.id,
        );
        if (index !== -1) {
          entitydatalist[index] = updatedLeagueGame;
          dispatch(setEntitydata(entitydatalist));
        }
        setLeagueGameEntity?.(updatedLeagueGame);

        //navigate(
        //  `/Events/${Entity?.id}/${Entity?.region}/undefined`,
        //  {
        //    state: { isCreate: false, team: Entity },
        //  },
        //);
      }
    } catch (err) {
      console.error("Failed to start game:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const handleCollectPayHelcim = async () => {
    try {
      setIsLoadingPay(true);
      setIsShowPayPopup(false);
      const amount = parseFloat(payAmount.replace("$", ""));

      if (isNaN(amount) || amount <= 0) {
        throw new Error("Invalid amount selected.");
      }

      // Construct CollectOptions
      const collectOptions: AV.ICollectOptions = {
        collectReason: "F", // "F" for Fee
        personAmount: amount,
        currency: "USD",
        collectType: "Members",
        showPersonResults: false,
        trackByPerson: false,
        chargeFee: false,
        perPersonFee: false,
        target: Entity
          ? AV.AVEntity.getLink(Entity as AV.IAVEntity)
          : AV.AVEntity.getLink(currentUser as AV.IAVEntity),
      };

      // Get payment token
      const token = await AV.Pay.createPayment(collectOptions);

      if (token) {
        // Initialize Helcim payment
        await initHelcimPayment(
          token,
          amount,
          currentUser?.email || "",
          currentUser?.name || "",
        );
      } else {
        setIsLoadingPay(false);
        throw new Error("Failed to create payment token");
      }
      setIsLoadingPay(false);
    } catch (error) {
      console.error("Error creating payment:", error);
    }
  };

  //#region HelcimPayment Section

  // Add these variables at component level
  const [initData, setInitData] = useState<AV.IPayInitResp | null>(null);
  const [verify, setVerify] = useState<AV.IPayResultResp | null>(null);
  const tokenRef = useRef<string | null>(null);

  // Use ref to keep latest initData for use in event listener
  const initDataRef = useRef<AV.IPayInitResp | null>(null);
  useEffect(() => {
    initDataRef.current = initData;
  }, [initData]);

  // NOTE: Add Helcim script only once globally (public/index.html) – avoid TOKEN_LENGTH redeclare error.

  // Add event listener once on mount
  useEffect(() => {
    window.addEventListener("message", handleHelcimResponse);
    return () => {
      window.removeEventListener("message", handleHelcimResponse);
    };
  }, []);

  const initHelcimPayment = async (
    token: string,
    amount: number,
    email: string,
    name: string,
  ) => {
    try {
      setPageLoader(true);
      tokenRef.current = token;

      const response = await fetch("/api/pay/HInit", {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({ token, amount, email, name }),
      });

      const data = await response.json();
      setInitData(data); // update state
      initDataRef.current = data; // keep ref in sync

      appendHelcimPayIframe(data.checkoutToken, true);

      setTimeout(() => {
        setPageLoader(false);
      }, 5000);
    } catch (error) {
      console.error("Payment initialization failed:", error);
      setPageLoader(false);
      throw error;
    }
  };

  const handleHelcimResponse = async (event: MessageEvent) => {
    const currentInitData = initDataRef.current;
    if (!currentInitData) return;

    const expectedKey = "helcim-pay-js-" + currentInitData.checkoutToken;

    if (event.data.eventName === expectedKey) {
      const status = event.data.eventStatus;
      const message = event.data.eventMessage;

      if (status === "ABORTED") {
        console.warn("Transaction aborted:", message);
      }

      if (status === "SUCCESS") {
        console.log("Transaction success:", message);
        try {
          const response = JSON.parse(message).data;

          await handlePaymentResult({
            checkoutToken: currentInitData.checkoutToken,
            data: response,
          });
        } catch (err) {
          console.error(
            "Failed parsing or handling Helcim success message:",
            err,
          );
        }
      }
    }
  };

  const handlePaymentResult = async (paymentData: PaymentData) => {
    try {
      const payload = {
        token: tokenRef.current ?? "",
        checkoutToken: paymentData.checkoutToken,
        data: {
          hash: paymentData.data.hash,
          data: JSON.stringify(paymentData.data.data),
        },
      };

      const response = await fetch("/api/pay/HResult", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Payment verification result:", result);
      setVerify(result);

      if (result?.status === "OK") {
        console.log("Payment verified successfully");
      } else {
        console.warn("Payment verification failed on backend");
      }

      const index = Entity?.participants?.findIndex(
        (x) => x?.id === currentUser?.id,
      );

      if (index !== -1) {
        const updatedParticipants = [...Entity.participants];
        const participant = { ...updatedParticipants[index] };

        // Ensure donations array exists
        let donations = participant.donantions || [];

        // Find existing donation (same user)
        const donationIndex = donations.findIndex(
          (d) => d?.id === currentUser?.id,
        );

        if (donationIndex !== -1) {
          // Update existing donation
          donations[donationIndex] = {
            ...donations[donationIndex],
            amount:
              Number(donations[donationIndex].amount || 0) + Number(payAmount),
          };
        } else {
          // Add new donation
          donations.push({
            id: currentUser?.id,
            amount: Number(payAmount),
            title: currentUser?.name,
            region: currentUser?.region,
            type: currentUser?.type,
          });
        }

        participant.donantions = donations;
        participant.amount = (participant.amount || 0) + Number(payAmount);

        updatedParticipants[index] = participant;

        const updatedEntity = {
          ...Entity,
          participants: updatedParticipants,
        };

        setEntity?.(updatedEntity);

        const entityIndex = entitydatalist?.findIndex(
          (x) => x?.id === Entity?.id,
        );

        if (entityIndex !== -1) {
          const updatedList = [...entitydatalist];
          updatedList[entityIndex] = updatedEntity;
          dispatch(setEntitydata(updatedList));
        }
      }

      setIsShowPayPopup(false);
      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    } catch (error) {
      console.error("Payment verification failed (frontend):", error);
      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }
  };

  //#endregion HelcimPayment Section

  const checkExpired = (date?: string | Date): boolean => {
    if (!date) return false;

    const targetDate = typeof date === "string" ? new Date(date) : date;
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays < 0;
  };

  const isSelfDeletedUser =
    (Entity?.type === "Person" || Entity?.type === "Pet") &&
    Entity?.status === "Deleted" &&
    userID === Entity?.id;

  const isAdminHiddenUser =
    isAdminView &&
    !participantUser &&
    Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
    EntityType?.status !== "Canceled";

  return (
    <>
      <Box
        height={"auto"}
        zIndex={-3}
        backgroundColor={"AVColor.white"}
        shadow={1}
        borderTopLeftRadius={10}
        borderTopRightRadius={10}
      >
        <Box
          height={
            type === "Feedback"
              ? "140px"
              : (Entity?.type === "Event" ||
                    (Entity?.type === "Game" && Entity?.teams?.length === 0)) &&
                  !Entity?.profile?.background?.id &&
                  !isShowEdit
                ? "95px"
                : (Entity?.type === "Event" ||
                      (Entity?.type === "Game" &&
                        Entity?.teams?.length === 0)) &&
                    !Entity?.profile?.background?.id &&
                    isShowEdit
                  ? "42px"
                  : leagueGameEntity?.status === "Started" &&
                      Entity?.profile?.background?.id &&
                      !isShowEdit
                    ? "95px"
                    : "230px"
          }
          backgroundColor={
            (Entity?.type === "Event" || Entity?.type === "Game") &&
            !Entity?.profile?.background?.id
              ? "white"
              : leagueGameEntity?.status === "Started" &&
                  Entity?.profile?.background?.id
                ? "white"
                : "AVColor.hovercolor2"
          }
          borderTopLeftRadius={10}
          borderTopRightRadius={10}
        >
          {/*Background*/}
          {(!leagueGameEntity || leagueGameEntity?.status !== "Started") && (
            <AVCoverPic
              Entity={Entity}
              setEntity={setEntity}
              openPreview={openPreview}
              isShowEdit={isShowEdit}
              handleUpload={handleUpload}
              profile={profile}
              isCreate={isCreate}
              setProfile={setProfile}
              type={type}
              isAdminView={isAdminView}
              editAccess={editAccess || isEntireSeriesAvailable}
              isShowPicker={isShowPicker}
              setIsShowpicker={setIsShowpicker}
              imageLoader={imageLoader}
              setImageLoader={setImageLoader}
            />
          )}

          {/*Follow and FavouriteIcon*/}
          {!isCreate && !isShowEdit && isDeleted && (
            <Box
              width={"100%"}
              alignItems={"flex-end"}
              right={"27px"}
              top={
                Entity?.type === "Event" && !Entity?.profile?.background?.id
                  ? "37px"
                  : Entity?.type === "Game" &&
                      Entity?.teams?.length === 0 &&
                      !Entity?.profile?.background?.id
                    ? "55px"
                    : Entity?.type === "Game" &&
                        Entity?.teams?.length > 0 &&
                        !Entity?.profile?.background?.id &&
                        !isShowEdit
                      ? "12px"
                      : "25px"
              }
            >
              <HStack space={3}>
                {/* Host Live Icon */}
                {Entity?.type !== "Event" &&
                  Entity?.type !== "Game" &&
                  Entity?.type !== "Collect" &&
                  isAdminView && (
                    <Tooltip openDelay={500} label={"Live"}>
                      <Button
                        width={"40px"}
                        height={"40px"}
                        rounded={"full"}
                        bgColor={"#32AE78"}
                        p={0}
                        onPress={() => {
                          dispatch(setShowLiveHostModal(true));
                          dispatch(setLiveEntity(Entity));
                        }}
                      >
                        <LivestreamIcon />
                      </Button>
                    </Tooltip>
                  )}

                {/* Follow */}
                {Entity?.type !== "Collect" &&
                  !isFollowing &&
                  !requestSent &&
                  !isAdminView &&
                  currentUser?.autoFollows?.filter((x) => x?.id === Entity?.id)
                    ?.length == 0 &&
                  currentUser?.id !== Entity?.id &&
                  EntityType?.type !== "Event" &&
                  EntityType?.type !== "Game" && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.follow.follow}
                    >
                      <Button
                        width={"40px"}
                        height={"40px"}
                        rounded={"full"}
                        bgColor={"#32AE78"}
                        onPress={() => {
                          handleFollowProfile("follow", Entity?.name ?? "");
                        }}
                        isLoading={followRequestSending}
                      >
                        <AddIcon size={"22px"} color={"AVColor.white"} />
                      </Button>
                    </Tooltip>
                  )}

                {/*Request sent*/}
                {Entity?.type !== "Collect" &&
                  requestSent &&
                  !isAdminView &&
                  Entity?.type !== "Pet" &&
                  currentUser?.id !== Entity?.id &&
                  EntityType?.type !== "Event" &&
                  EntityType?.type !== "Game" && (
                    <Button
                      pl={2}
                      pr={4}
                      py={2}
                      borderRadius={"45px"}
                      minWidth={"120px"}
                      bgColor={"#32AE78"}
                      _text={{ color: "AVColor.primaryText" }}
                    >
                      {Loc.currentLang.menu.requestSent}
                    </Button>
                  )}

                {/*FavouriteIcon*/}
                {Entity?.type !== "Collect" &&
                  !isMyFavourite &&
                  currentUser?.id !== Entity?.id &&
                  Entity?.type !== "Event" &&
                  Entity?.type !== "Game" && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.menu.favourite}
                    >
                      <Button
                        width={"40px"}
                        height={"40px"}
                        rounded={"full"}
                        bgColor={"#32AE78"}
                        isLoading={isFavLoader}
                        onPress={() => handleFavourite("addFavourite")}
                      >
                        <FavouriteIcon size={"22px"} color={"AVColor.white"} />
                      </Button>
                    </Tooltip>
                  )}

                {Entity?.type !== "Collect" &&
                  currentUser?.id !== Entity?.id &&
                  Entity?.type !== "Event" &&
                  Entity?.type !== "Game" &&
                  Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
                  (isMemberOfEntity ||
                    isPlayerOfEntity ||
                    isstaffOfEntity ||
                    ((Entity?.type == "Person" || Entity?.type == "Pet") &&
                      currentUser?.id !== Entity?.id)) && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.activity.chat}
                    >
                      <Button
                        width={"40px"}
                        height={"40px"}
                        isDisabled={!isOnline}
                        rounded={"full"}
                        bgColor={"#32AE78"}
                        onPress={() =>
                          HandleGroupChat(
                            Entity?.type == "PlayerOrg" &&
                              Entity?.subType == undefined
                              ? "A"
                              : "W",
                          )
                        }
                        isLoading={isLoad}
                      >
                        <GroupChatIcon size={23} color={"white"} />
                      </Button>
                    </Tooltip>
                  )}

                {(Entity?.type === "Event" || Entity?.type === "Game") && (
                  <RenderRsvp entity={Entity} />
                )}

                {((Entity?.type !== "Event" &&
                  Entity?.type !== "Game" &&
                  Entity?.type !== "Collect") ||
                  (Entity?.type === "Collect" && !checkExpired(Entity?.end))) &&
                  isAdminView &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" && (
                    <Pressable
                      width="40px"
                      height="40px"
                      alignItems="center"
                      justifyContent="center"
                      bg="gray.100"
                      _hover={{ bg: "gray.50" }}
                      rounded="full"
                      onPress={() => setIsOpen(!isOpen)}
                    >
                      <MoreHorizontalIcon
                        size="24px"
                        color={"AVColor.primaryText"}
                        alignSelf={"center"}
                      />
                    </Pressable>
                  )}

                {!isAdminView &&
                  Entity?.type !== "Event" &&
                  Entity?.type !== "Game" &&
                  Entity?.type !== "Collect" &&
                  Entity?.status !== "Canceled" &&
                  Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" && (
                    <Pressable
                      width="40px"
                      height="40px"
                      alignItems="center"
                      justifyContent="center"
                      bg="gray.100"
                      _hover={{ bg: "gray.50" }}
                      rounded="full"
                      onPress={(e) => {
                        e.stopPropagation();
                        setIsOpen(!isOpen);
                      }}
                    >
                      <MoreHorizontalIcon
                        size="24px"
                        color={"AVColor.primaryText"}
                        alignSelf={"center"}
                      />
                    </Pressable>
                  )}
              </HStack>

              {!isAdminView &&
                Entity?.type === "Collect" &&
                !isCollectFullyPaid && (
                  <Button
                    width={"100px"}
                    height="auto"
                    backgroundColor="#32AE78"
                    rounded="full"
                    isDisabled={!isOnline}
                    onPress={() => setIsShowPayPopup(true)}
                  >
                    <Text color="white">
                      {Loc.currentLang.feeCollect.payCaps}
                    </Text>
                  </Button>
                )}

              {Entity?.type !== "Event" &&
                Entity?.type !== "Game" &&
                isOpen &&
                isAdminView && (
                  <VStack
                    ref={menuRef}
                    width={"130px"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"30px"}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    {Entity?.type !== "Collect" &&
                    Entity?.parent?.type === "School" &&
                    Entity?.subType == "GradClass" ? (
                      <>
                        <Pressable
                          ref={menuRef}
                          width={"100%"}
                          height={"36px"}
                          paddingX={"10px"}
                          alignItems={"flex-start"}
                          justifyContent={"center"}
                          onPress={async () => {
                            try {
                              setIsLoader(true);
                              await handleMatriculate();
                            } finally {
                              setIsLoader(false);
                              setIsOpen(!isOpen);
                            }
                          }}
                          _hover={{
                            backgroundColor: "gray.100",
                          }}
                          isDisabled={isLoader}
                        >
                          {isLoader ? (
                            <HStack alignItems="center" space={2}>
                              <Spinner size="sm" color="AVColor.primary" />
                              <Text fontSize={"14px"} fontFamily={"Roboto"}>
                                {Loc.currentLang.menu.matriculating}
                              </Text>
                            </HStack>
                          ) : (
                            <Text fontSize={"14px"} fontFamily={"Roboto"}>
                              {Loc.currentLang.menu.matriculate}
                            </Text>
                          )}
                        </Pressable>

                        <Divider />

                        <Pressable
                          ref={menuRef}
                          width={"100%"}
                          height={"36px"}
                          paddingX={"10px"}
                          alignItems={"flex-start"}
                          justifyContent={"center"}
                          onPress={() => {
                            navigate(
                              `/accountsettings/${Entity?.id}/${Entity?.region}`,
                              {
                                state: {
                                  page: pathName,
                                  Entity: Entity,
                                },
                              },
                            );
                          }}
                          _hover={{
                            backgroundColor: "gray.100",
                          }}
                        >
                          <Text fontSize={"14px"} fontFamily={"Roboto"}>
                            {Loc.currentLang.menu.setting}
                          </Text>
                        </Pressable>
                      </>
                    ) : (
                      <>
                        <Pressable
                          ref={menuRef}
                          width={"100%"}
                          height={"36px"}
                          paddingX={"10px"}
                          alignItems={"flex-start"}
                          justifyContent={"center"}
                          onPress={() => {
                            Entity?.series && seriesEventData
                              ? setIsShowEditOccurence(true)
                              : setIsShowEdit(true);
                            setIsOpen(false);
                          }}
                          _hover={{
                            backgroundColor: "gray.100",
                          }}
                        >
                          <Text fontSize={"14px"} fontFamily={"Roboto"}>
                            {Loc.currentLang.menu.edit}
                          </Text>
                        </Pressable>

                        {Entity?.type !== "Collect" && (
                          <>
                            <Divider />

                            <Pressable
                              ref={menuRef}
                              width={"100%"}
                              height={"36px"}
                              paddingX={"10px"}
                              alignItems={"flex-start"}
                              justifyContent={"center"}
                              onPress={() => {
                                Entity?.type == "Person" ||
                                Entity?.type == "Pet"
                                  ? navigate(
                                      `/accountsettings/${currentUser?.id}/${currentUser?.region}`,
                                      {
                                        state: {
                                          page: "Home",
                                        },
                                      },
                                    )
                                  : navigate(
                                      `/accountsettings/${Entity?.id}/${Entity?.region}`,
                                      {
                                        state: {
                                          page: pathName,
                                          Entity: Entity,
                                        },
                                      },
                                    );
                              }}
                              _hover={{
                                backgroundColor: "gray.100",
                              }}
                            >
                              <Text fontSize={"14px"} fontFamily={"Roboto"}>
                                {Loc.currentLang.menu.setting}
                              </Text>
                            </Pressable>
                          </>
                        )}
                      </>
                    )}
                  </VStack>
                )}

              {isOpen &&
                !isAdminView &&
                Entity?.type !== "Person" &&
                Entity?.type !== "Pet" &&
                Entity?.type !== "Event" &&
                Entity?.type !== "Game" &&
                Entity?.type !== "Collect" && (
                  <VStack
                    width={"185x"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"50px"}
                    zIndex={999}
                    borderRadius={"6px"}
                    ref={menuRef}
                  >
                    <Pressable
                      width={"100%"}
                      height={"36px"}
                      paddingX={"5px"}
                      paddingY={"5px"}
                      _hover={{
                        backgroundColor: "gray.100",
                      }}
                      alignItems={"flex-start"}
                      justifyContent={"center"}
                      onPress={() => {
                        setIsStaffReq(true);
                        setIsOpen(false);
                      }}
                    >
                      <Text fontSize={"14px"} fontFamily={"Roboto"}>
                        {Loc.currentLang.menu.requestToJoinStaff}
                      </Text>
                    </Pressable>

                    <Divider />

                    <Pressable
                      width={"100%"}
                      height={"36px"}
                      paddingX={"5px"}
                      paddingY={"5px"}
                      _hover={{
                        backgroundColor: "gray.100",
                      }}
                      alignItems={"flex-start"}
                      justifyContent={"center"}
                      onPress={() => {
                        setIsChildOrgReq(true);
                        setIsOpen(false);
                      }}
                    >
                      <Text
                        paddingX={1}
                        numberOfLines={2}
                        fontSize={"14px"}
                        fontFamily={"Roboto"}
                      >
                        {Loc.currentLang.menu.requestToAddChildOrganization
                          ? Loc.currentLang.menu.requestToAddChildOrganization
                          : "Request to Add ChilOrganization"}
                      </Text>
                    </Pressable>
                  </VStack>
                )}

              {isOpen &&
                !isAdminView &&
                (Entity?.type == "Person" || Entity?.type == "Pet") && (
                  <VStack
                    ref={menuRef}
                    width={"128px"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"24px"}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    {!isBlock ? (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        justifyContent={"center"}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        isLoading={isBlockLoad}
                        onPress={() => {
                          HandleBlockUser("block", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.block}
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        alignItems={"flex-start"}
                        justifyContent={"center"}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        onPress={() => {
                          HandleUnBlockUser("unblock", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                        isLoading={isBlockLoad}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.unBlock}
                        </Text>
                      </Button>
                    )}

                    {currentUser?.follows?.filter((x) => x?.id == Entity?.id)
                      ?.length > 0 && (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        justifyContent={"center"}
                        onPress={() => {
                          handleFollowProfile("unfollow", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.unfollow}
                        </Text>
                      </Button>
                    )}
                  </VStack>
                )}
            </Box>
          )}
        </Box>

        {/* Profile */}
        {Entity?.type === "Game" && Entity?.teams?.length > 0 && !isShowEdit ? (
          <HStack
            position="absolute"
            top={!Entity?.profile?.background?.id ? "100px" : "300px"}
            left={isMobile ? "2%" : "5%"}
            //alignItems="center"
            //space={6}
            //style={isMobile ? { transform: "translateX(-50%)" } : undefined}
            //zIndex={-3}
            width={isMobile ? "100%" : "auto"}
          >
            <HStack
              flexDirection={isMobile ? "column" : "row"}
              alignItems="center"
              justifyContent="center"
              space={isMobile ? 2 : 6}
            >
              {/* Home Team Info */}
              <Box minW="140px" top="0px" padding="8px" alignItems="center">
                <Text fontSize="14px" color="coolGray.600">
                  Home Team
                </Text>
                <Text
                  fontSize="16px"
                  fontWeight="600"
                  color="#00A7BC"
                  numberOfLines={1}
                >
                  {Entity?.parent?.title}
                </Text>
              </Box>

              {/* Home Team */}
              <Box position="relative" left="-10px">
                <AVProfilePic
                  isMyFavourite={isMyFavourite}
                  isShowEdit={isShowEdit}
                  EntityType={EntityType}
                  handleFavourite={handleFavourite}
                  leagueGameEntity={leagueGameEntity}
                  Entity={Entity}
                  setEntity={setEntity}
                  isLoader={isFavLoader}
                  handleUpload={handleUpload}
                  profile={profile}
                  isCreate={isCreate}
                  setProfile={setProfile}
                  type={type}
                  isAdminView={isAdminView}
                  editAccess={editAccess || isEntireSeriesAvailable}
                  imageLoader={imageLoader}
                  setImageLoader={setImageLoader}
                  openPreview={openPreview}
                  isInline={true}
                />
              </Box>

              {/* VS */}
              <Text
                fontSize={isMobile ? "12px" : "14px"}
                fontWeight="700"
                color="coolGray.500"
                marginY={isMobile ? "6px" : "0"}
              >
                VS
              </Text>

              {/* Guest Team */}
              <Box position="relative">
                <AVProfilePic
                  isMyFavourite={isMyFavourite}
                  isShowEdit={isShowEdit}
                  EntityType={EntityType}
                  handleFavourite={handleFavourite}
                  leagueGameEntity={leagueGameEntity}
                  Entity={Entity}
                  setEntity={setEntity}
                  isLoader={isFavLoader}
                  handleUpload={handleUpload}
                  profile={profile}
                  isCreate={isCreate}
                  setProfile={setProfile}
                  type={type}
                  isAdminView={isAdminView}
                  editAccess={editAccess || isEntireSeriesAvailable}
                  imageLoader={imageLoader}
                  setImageLoader={setImageLoader}
                  openPreview={openPreview}
                  isInline={true}
                />
              </Box>

              {/* Add Guest Team/Guest Team Info */}
              <Box
                minW="140px"
                top="0px"
                left="20px"
                padding="8px"
                alignItems="center"
              >
                {(leagueGameEntity?.teams?.length ?? 0) > 1 ? (
                  <>
                    <Text fontSize="14px" color="coolGray.600">
                      Guest Team
                    </Text>

                    <Text
                      fontSize="16px"
                      fontWeight="600"
                      color="#00A7BC"
                      numberOfLines={1}
                    >
                      {
                        leagueGameEntity?.teams?.find(
                          (x) => x.id !== Entity?.parent?.id,
                        )?.title
                      }
                    </Text>
                  </>
                ) : (
                  <>
                    <Text fontSize="14px" fontWeight="400" color="#32AE78">
                      Add Guest Team
                    </Text>

                    <Button
                      top="5px"
                      width="36px"
                      height="36px"
                      bg="gray.100"
                      rounded="full"
                      shadow={1}
                      p={0}
                      _hover={{ bgColor: "gray.50" }}
                      onPress={() => {
                        clearSearch();
                        setIsShowAddGuestTeam(true);
                      }}
                    >
                      <AddIcon size="20px" color="#32AE78" />
                    </Button>
                  </>
                )}
              </Box>
            </HStack>
          </HStack>
        ) : (
          Entity?.type !== "Collect" && (
            <AVProfilePic
              isMyFavourite={isMyFavourite}
              isShowEdit={isShowEdit}
              EntityType={EntityType}
              handleFavourite={handleFavourite}
              leagueGameEntity={leagueGameEntity}
              Entity={Entity}
              setEntity={setEntity}
              isLoader={isFavLoader}
              handleUpload={handleUpload}
              profile={profile}
              isCreate={isCreate}
              setProfile={setProfile}
              type={type}
              isAdminView={isAdminView}
              editAccess={editAccess || isEntireSeriesAvailable}
              imageLoader={imageLoader}
              setImageLoader={setImageLoader}
              openPreview={openPreview}
            />
          )
        )}

        {(Entity?.type === "Event" || Entity?.type === "Game") &&
          !isShowEdit && (
            <VStack
              position={"absolute"}
              left={
                isMobile
                  ? "187px"
                  : Entity?.eventType === "Game" &&
                      Entity?.teams?.length === 0 &&
                      leagueGameEntity?.status === "Started"
                    ? "175px"
                    : Entity?.eventType === "Game" &&
                        Entity?.teams?.length === 0 &&
                        Entity?.profile?.background?.id
                      ? "215px"
                      : !Entity?.profile?.background?.id
                        ? "250px"
                        : "194px"
              }
              //left={
              //  isMobile
              //    ? "187px"
              //    : Entity?.type === "Game" && Entity?.teams?.length > 0
              //      ? "30px"
              //      : Entity?.type === "Game" && Entity?.teams?.length === 0
              //        ? "230px"
              //        : "250px"
              //}
              width={
                Entity?.eventType === "Game" &&
                Entity?.teams?.length === 0 &&
                leagueGameEntity?.status === "Started"
                  ? "50%"
                  : Entity?.eventType === "Game" &&
                      Entity?.teams?.length === 0 &&
                      Entity?.profile?.background?.id
                    ? "31%"
                    : isShowPicker && !Entity?.profile?.background?.id
                      ? "15%"
                      : "40%"
              }
              //width={
              //  isShowPicker && !Entity?.profile?.background?.id ? "15%" : "40%"
              //}
              top={
                Entity?.eventType === "Game" &&
                Entity?.teams?.length === 0 &&
                leagueGameEntity?.status === "Started"
                  ? "0px"
                  : Entity?.eventType === "Game" &&
                      Entity?.teams?.length === 0 &&
                      Entity?.profile?.background?.id
                    ? "250px"
                    : !Entity?.profile?.background?.id
                      ? "35px"
                      : "236px"
              }
              //top={
              //  Entity?.type === "Event" && !Entity?.profile?.background?.id
              //    ? "35px"
              //    : Entity?.type === "Game" &&
              //        Entity?.profile?.background?.id
              //      ? "240px"
              //      : "228px"
              //}
              paddingTop={"12px"}
            >
              <HStack width={"100%"}>
                <Text
                  fontWeight={500}
                  fontSize={"24px"}
                  numberOfLines={1}
                  width={"100%"}
                >
                  {Entity?.name}
                </Text>
              </HStack>

              <HStack
                width={
                  Entity?.type === "Game" && Entity?.teams?.length === 0
                    ? "70%"
                    : "100%"
                }
              >
                <Pressable
                  width={
                    Entity?.type === "Game" && Entity?.teams?.length === 0
                      ? "70%"
                      : "100%"
                  }
                  onPress={() => {
                    setLeagueGameEntity(undefined);

                    if (Owner?.type === "Person" || Owner?.type === "Pet") {
                      navigate(`/profile/${Owner?.id}/${Owner?.region}`, {
                        state: {
                          user: {
                            id: Owner?.id,
                            pk: Owner?.pk,
                            region: Owner?.region,
                            type: Owner?.type,
                            name: Owner?.title,
                          },
                        },
                      });
                    } else if (Owner?.type === "PlayerOrg") {
                      navigate(`/season/${Owner?.id}/${Owner?.region}`, {
                        state: { isCreate: false, team: Owner },
                      });
                    } else if (Owner?.type === "Team") {
                      navigate(`/teams/${Owner?.id}/${Owner?.region}`, {
                        state: { isCreate: false, team: Owner },
                      });
                    } else {
                      navigate(`/season/${Owner?.id}/${Owner?.region}`, {
                        state: { isCreate: false, team: Owner },
                      });
                    }
                  }}
                >
                  <Text
                    fontWeight={400}
                    fontSize={"16px"}
                    width={"100%"}
                    numberOfLines={1}
                    color={"#00A7BC"}
                  >
                    {Owner?.type === "PlayerOrg"
                      ? Owner?.name?.trim()?.length > 0
                        ? Owner?.name
                        : Owner?.data || Owner?.title
                      : Owner?.title || Owner?.name}
                  </Text>
                </Pressable>
              </HStack>
            </VStack>
          )}

        {/* Title*/}
        {!isCreate && !isShowEdit && (
          <VStack
            height={"auto"}
            marginTop={
              //Entity?.type === "Game" && Entity?.teams?.length > 0
              //  ? "unset"
              //  : Entity?.type === "Game" && Entity?.teams?.length === 0
              //    ? "12px" : "55px"
              Entity?.eventType === "Game" &&
              Entity?.teams?.length === 0 &&
              leagueGameEntity?.status === "Started"
                ? "30px"
                : "55px"
            }
            //marginTop={
            //  !Entity?.profile?.background?.id &&
            //  !isShowEdit
            //    ? "140px"
            //    : Entity?.type === "Game" &&
            //        Entity?.profile?.background?.id &&
            //        !isShowEdit
            //      ? "200px"
            //      : "55px"
            //}
            marginBottom={
              Entity?.type === "Event" ||
              (Entity?.type === "Game" && Entity?.teams?.length === 0)
                ? "unset"
                : "22px"
            }
            width={"100%"}
            zIndex={-3}
          >
            <AVHeaderTitle
              Entity={Entity}
              EntityType={EntityType}
              homeTeam={homeTeam}
              guestTeam={guestTeam}
              showGameInfo={showGameInfo}
              leagueGameEntity={leagueGameEntity}
              googlemap={googlemap}
              weatherURL={weatherURL}
              weather={weather}
              setIsImagePopup={setIsImagePopup}
              seriesEvent={seriesEvent}
              isAdminView={isAdminView}
              setClickedUrl={setClickedUrl}
              setShowConfirmLinkPopup={setShowConfirmLinkPopup}
            />

            {!isDeleted &&
              (Entity?.type == "Person" || Entity?.type == "Pet"
                ? !isAdminView
                : isAdminView) &&
              !isCreate &&
              !isShowEdit && (
                <HStack
                  justifyContent={"flex-end"}
                  marginTop={"24px"}
                  marginX={"24px"}
                >
                  {(isSelfDeletedUser || isAdminHiddenUser) && (
                    <Button
                      width={"246px"}
                      bgColor={"#32AE78"}
                      rounded="full"
                      color="#fff"
                      p={2}
                      justifyContent={"center"}
                      height={"40px"}
                      borderRadius={"20px"}
                      onPress={HandleRestoreAccount}
                    >
                      <Text color={"white"}>
                        {Loc.currentLang.menu.restoreyourAccount}
                      </Text>
                    </Button>
                  )}
                </HStack>
              )}

            {Entity?.status === "Deleted" &&
              !isDeleted &&
              (Entity?.type == "Person" || Entity?.type == "Pet"
                ? isAdminView
                : !isAdminView) &&
              !isCreate &&
              !isShowEdit && (
                <VStack alignItems={"center"} marginTop={"35px"}>
                  <img
                    src={Deleted}
                    alt="image"
                    height={"220px"}
                    width={"240px"}
                  />
                  <HStack paddingBottom={"8px"}>
                    <Text fontWeight={400} fontSize={"18px"}>
                      {Loc.currentLang.menu.noLongerTxt}
                    </Text>
                  </HStack>
                  <HStack>
                    <Text>{Loc.currentLang.menu.restrictPostTxt}</Text>
                  </HStack>
                </VStack>
              )}
          </VStack>
        )}
      </Box>

      {/* SCORE / TIMELINE CONTENT */}
      {Entity?.type === "Game" &&
        (leagueGameEntity?.status === "Started" ||
          leagueGameEntity?.status === "Ended") &&
        !isShowEdit && (
          <>
            {/* ENDED */}
            {leagueGameEntity?.status === "Ended" && (
              <>
                <Divider thickness={1.5} />
                <Collapse isOpen={showScoreInfo}>
                  <Box width="100%">
                    <ScoreSection
                      props={props}
                      homeTeam={homeTeam}
                      guestTeam={guestTeam}
                      entity={Entity}
                      setEntity={setEntity}
                      setEntitydata={setEntitydata}
                      leagueGameEntity={leagueGameEntity}
                      setLeagueGameEntity={setLeagueGameEntity}
                      menuRef={menuRef}
                      showPeriodMenu={showPeriodMenu}
                      setShowPeriodMenu={setShowPeriodMenu}
                      entitydatalist={entitydatalist}
                      dispatch={dispatch}
                      isLoad={isLoad}
                      setisLoad={setisLoad}
                      isRsvpLoading={isRsvpLoading}
                      setIsRsvpLoading={setIsRsvpLoading}
                      isAdminView={isAdminView}
                      setIsAdminView={setIsAdminView}
                      editAccess={editAccess}
                      isEntireSeriesAvailable={isEntireSeriesAvailable}
                    />
                  </Box>
                </Collapse>
                <Divider thickness={1.5} />
              </>
            )}

            {/* STARTED */}
            {leagueGameEntity?.status === "Started" && (
              <Box width="100%">
                <ScoreSection
                  props={props}
                  homeTeam={homeTeam}
                  guestTeam={guestTeam}
                  entity={Entity}
                  setEntity={setEntity}
                  setEntitydata={setEntitydata}
                  leagueGameEntity={leagueGameEntity}
                  setLeagueGameEntity={setLeagueGameEntity}
                  menuRef={menuRef}
                  showPeriodMenu={showPeriodMenu}
                  setShowPeriodMenu={setShowPeriodMenu}
                  entitydatalist={entitydatalist}
                  dispatch={dispatch}
                  isLoad={isLoad}
                  setisLoad={setisLoad}
                  isRsvpLoading={isRsvpLoading}
                  setIsRsvpLoading={setIsRsvpLoading}
                  isAdminView={isAdminView}
                  setIsAdminView={setIsAdminView}
                  editAccess={editAccess}
                  isEntireSeriesAvailable={isEntireSeriesAvailable}
                />
              </Box>
            )}
          </>
        )}

      {isShowPayPopup && (
        <Box
          position="fixed"
          bgColor="AVColor.overlay2"
          top={0}
          bottom={0}
          left={0}
          right={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              isMobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              height: isMobile ? "650px" : "310px",
              marginTop: "12px",
            }}
          >
            <VStack width="100%" padding="24px" space={2}>
              {/* Header */}
              <HStack justifyContent="space-between" alignItems="center">
                <Text fontSize="24px" fontWeight="600">
                  {Entity?.name}
                </Text>

                <AVCancel
                  callback={() => {
                    setIsShowPayPopup(false);
                    //setPayAmount("");
                  }}
                  color={undefined}
                  size={undefined}
                />
              </HStack>

              {/* Description */}
              <Text fontSize="16px" color="coolGray.700">
                <Text
                  fontSize="14px"
                  color="coolGray.700"
                  noOfLines={2}
                  ellipsizeMode="tail"
                  marginBottom="16px"
                >
                  {Entity?.profile?.text ?? ""}
                </Text>
              </Text>

              {/* Remaining Amount */}
              <Text fontSize="16px" color="#32AE78">
                {`${Loc.currentLang.feeCollect.remainingAmount}: $${remainingAmount}`}
              </Text>

              {/* Input */}
              <Box width="95%" top="6px">
                <AVInputtext
                  type="text"
                  label={Loc.currentLang.feeCollect.enterAmount}
                  value={payAmount}
                  maxLength={7}
                  onChange={(e) => {
                    let input = e.target.value;

                    // Allow numbers and a single decimal point
                    input = input
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1");

                    // Limit to 2 decimal places
                    const parts = input.split(".");
                    if (parts[1]?.length > 2) {
                      input = `${parts[0]}.${parts[1].slice(0, 2)}`;
                    }

                    setPayAmount(input);
                  }}
                />
              </Box>

              {/* Action Button */}
              <HStack justifyContent="center" pt={2}>
                <Button
                  width="180px"
                  height="40px"
                  rounded="full"
                  backgroundColor="AVColor.primary"
                  isDisabled={
                    isLoadingPay ||
                    !payAmount?.trim() ||
                    Number(payAmount) <= 0 ||
                    Number(payAmount) > remainingAmount
                  }
                  isLoading={isLoadingPay}
                  onPress={handleCollectPayHelcim}
                >
                  <Text color="white" fontWeight="500">
                    {Loc.currentLang.feeCollect.doneCaps}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isShowAddGuestTeam && (
        <Box
          position="fixed"
          bgColor="AVColor.overlay2"
          top={0}
          bottom={0}
          left={0}
          right={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${isMobile && "create_post_popup_mobile"}`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              maxHeight: isMobile ? "90vh" : "80vh",
              marginTop: "12px",
              overflow: "hidden",
            }}
          >
            <VStack
              width="100%"
              padding="24px"
              space={4}
              maxH="100%"
              overflowY="auto"
            >
              {/* Header */}
              <HStack justifyContent="space-between" alignItems="center">
                <Text fontSize="20px" fontWeight="600">
                  Add Guest Team
                </Text>

                <AVCancel
                  callback={() => setIsShowAddGuestTeam(false)}
                  color={undefined}
                  size={undefined}
                />
              </HStack>

              {/* Inputs */}
              <HStack
                space={4}
                flexDirection={isMobile ? "column" : "row"}
                alignItems="flex-start"
              >
                {/* Team Search */}
                <Box flex={1} position="relative">
                  <Box
                    width="100%"
                    height="56px"
                    borderWidth={1}
                    borderColor="coolGray.300"
                    borderRadius="12px"
                    bg="white"
                    px={3}
                    display="flex"
                    justifyContent="center"
                  >
                    <HStack alignItems="center" space={2}>
                      <SearchIcon size="20px" color="coolGray.400" />

                      <Input
                        flex={1}
                        variant="unstyled"
                        value={searchQuery}
                        placeholder="Team Name *"
                        fontSize="14px"
                        //_focus={{ outline: "none" }}
                        onChangeText={handleSearchItems}
                      />

                      {searchQuery && (
                        <IconButton
                          icon={<CloseIcon size="xs" />}
                          variant="unstyled"
                          onPress={() => {
                            setSearchQuery("");
                            setSearchResults([]);
                            setSuggestions([]);
                          }}
                        />
                      )}
                    </HStack>
                  </Box>

                  {/* Selected Team */}
                  {selectedOrgs.length > 0 && (
                    <HStack mt={4} flexWrap="wrap">
                      {selectedOrgs.map((org) => (
                        <Box
                          key={org.id}
                          bg="white"
                          borderRadius="12px"
                          borderWidth={1}
                          borderColor="coolGray.200"
                          shadow={2}
                          width="110px"
                          height="120px"
                          m={2}
                          position="relative"
                        >
                          {/* Remove button */}
                          <IconButton
                            icon={<CloseIcon size="xs" />}
                            position="absolute"
                            top="0px"
                            right="0px"
                            variant="unstyled"
                            zIndex={9}
                            onPress={() => handleRemoveOrg(org?.id!)}
                          />

                          <VStack
                            alignItems="center"
                            justifyContent="center"
                            height="100%"
                            px={2}
                            space={2}
                          >
                            {/* Logo */}
                            <Box
                              width="50px"
                              height="50px"
                              borderRadius="full"
                              overflow="hidden"
                              bg="coolGray.100"
                              justifyContent="center"
                              alignItems="center"
                            >
                              {org?.thumb ? (
                                <Image
                                  source={{ uri: AV.Media.getThumb(org) }}
                                  alt={org?.title ?? ""}
                                  width="100%"
                                  height="100%"
                                />
                              ) : (
                                <EntityProfilePic
                                  width="50px"
                                  height="50px"
                                  link={org}
                                />
                              )}
                            </Box>

                            {/* Team name */}
                            <Text
                              fontWeight="600"
                              fontSize="12px"
                              textAlign="center"
                              numberOfLines={1}
                              mt={2}
                            >
                              {org.title}
                            </Text>

                            {/* Location */}
                            {org.data && (
                              <Text
                                fontSize="12px"
                                color="coolGray.500"
                                textAlign="center"
                                numberOfLines={1}
                              >
                                {org.data}
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      ))}
                    </HStack>
                  )}

                  {/* Suggestions Dropdown */}
                  {searchResults.length > 0 && (
                    <Box
                      position="absolute"
                      top="48px"
                      left={0}
                      right={0}
                      bg="white"
                      borderRadius="md"
                      shadow={4}
                      zIndex={2000}
                      maxH="260px"
                      overflowY="auto"
                    >
                      {searchResults.map((org) => (
                        <Pressable
                          key={org.id}
                          onPress={() => handleOrgSelect(org)}
                          p={3}
                          _hover={{ bg: "gray.50" }}
                        >
                          <HStack space={3} alignItems="center">
                            <EntityProfilePic
                              width="32px"
                              height="32px"
                              link={org}
                            />
                            <VStack>
                              <Text fontWeight="medium">{org.title}</Text>
                              {org.data && (
                                <Text fontSize="xs" color="gray.500">
                                  {org.data}
                                </Text>
                              )}
                            </VStack>
                          </HStack>
                        </Pressable>
                      ))}
                    </Box>
                  )}
                </Box>

                {/* Location */}
                <Box flex={1} mt={isMobile ? 3 : 0}>
                  <AVInputtext
                    type="text"
                    label="Location"
                    value={guestTeamLocation}
                    onChange={(e) => setGuestTeamLocation(e.target.value)}
                  />
                </Box>
              </HStack>

              {/* OR Divider */}
              <HStack alignItems="center" my="16px" zIndex="-3">
                <Divider flex={1} />
                <Text mx="12px" fontSize="12px" color="coolGray.500">
                  OR
                </Text>
                <Divider flex={1} />
              </HStack>

              {/* Invite Text */}
              <Text fontSize="14px" color="coolGray.600" textAlign="center">
                Invite team using your social media contacts or your address
                book.
              </Text>

              {/* Social Buttons */}
              <HStack
                justifyContent="center"
                space={4}
                flexWrap="wrap"
                zIndex="-3"
              >
                <Pressable
                  alignItems="center"
                  borderWidth={1}
                  borderColor="coolGray.200"
                  borderRadius="8px"
                  p="16px"
                  width="120px"
                >
                  <InstagramIcon width="26" height="26" />
                  <Text mt="8px" fontSize="12px">
                    Instagram
                  </Text>
                </Pressable>

                <Pressable
                  alignItems="center"
                  borderWidth={1}
                  borderColor="coolGray.200"
                  borderRadius="8px"
                  p="16px"
                  width="120px"
                >
                  <FacebookIcon width="26" height="26" />
                  <Text mt="8px" fontSize="12px">
                    Facebook
                  </Text>
                </Pressable>

                <Pressable
                  alignItems="center"
                  borderWidth={1}
                  borderColor="coolGray.200"
                  borderRadius="8px"
                  p="16px"
                  width="120px"
                >
                  <ShapeContectIcon width="26" height="26" />
                  <Text mt="8px" fontSize="12px">
                    Contacts
                  </Text>
                </Pressable>
              </HStack>

              {/* Footer */}
              <HStack
                justifyContent={isMobile ? "center" : "flex-end"}
                space={3}
                mt="24px"
                flexWrap="wrap"
                zIndex={-3}
              >
                <Button
                  variant="ghost"
                  rounded="full"
                  onPress={() => {
                    clearSearch();
                    setIsShowAddGuestTeam(true);
                  }}
                >
                  <Text color="coolGray.600">CANCEL</Text>
                </Button>

                <Button
                  bgColor="#32AE78"
                  rounded="full"
                  px="24px"
                  isDisabled={selectedOrgs.length === 0}
                  isLoading={isLoader}
                  onPress={handleAddGuestTeam}
                >
                  <Text color="white" fontWeight="600">
                    ADD TEAM
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}
    </>
  );
};

const ScoreSection = ({
  props,
  homeTeam,
  guestTeam,
  entity,
  setEntity,
  setEntitydata,
  leagueGameEntity,
  setLeagueGameEntity,
  menuRef,
  showPeriodMenu,
  setShowPeriodMenu,
  entitydatalist,
  dispatch,
  isLoad,
  setisLoad,
  isRsvpLoading,
  setIsRsvpLoading,
  isAdminView,
  setIsAdminView,
  editAccess,
  isEntireSeriesAvailable,
}) => {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [gameClock, setGameClock] = useState("00:00");
  const [homeScore, setHomeScore] = useState(0);
  const [guestScore, setGuestScore] = useState(0);
  const [period, setPeriod] = useState("1st Period");
  const [activeTab, setActiveTab] = useState<"score" | "timeline" | "chat">(
    "score",
  );
  const [deleteLoadingId, setDeleteLoadingId] = useState<string | null>(null);
  const isGameEnded = leagueGameEntity?.status === "Ended";
  const isGameStarted = leagueGameEntity?.status === "Started";
  //const isGameEnded =
  //  leagueGameEntity?.status === "Ended" ||
  //  (!editAccess && !isEntireSeriesAvailable);

  const periods = [
    {
      label: Loc.currentLang.gameEvent.firstPeriod,
      value: "1st Period",
    },
    {
      label: Loc.currentLang.gameEvent.secondPeriod,
      value: "2nd Period",
    },
    {
      label: Loc.currentLang.gameEvent.thirdPeriod,
      value: "3rd Period",
    },
    {
      label: Loc.currentLang.gameEvent.fourthPeriod,
      value: "4th Period",
    },
  ];

  const [timelineData, setTimelineData] = useState<
    {
      id: number;
      time: string;
      period: string;
      text: string;
    }[]
  >([]);

  const formatTime = (v: number) => String(v).padStart(2, "0");

  const increaseTime = () => {
    if (seconds === 59) {
      setMinutes((prev) => prev + 1);
      setSeconds(0);
    } else {
      setSeconds((prev) => prev + 1);
    }
  };

  const decreaseTime = () => {
    if (minutes === 0 && seconds === 0) return;

    if (seconds === 0) {
      setMinutes((prev) => Math.max(0, prev - 1));
      setSeconds(59);
    } else {
      setSeconds((prev) => prev - 1);
    }
  };

  const handleAddScore = async () => {
    try {
      setIsRsvpLoading(true);

      const scorePayload = {
        gameClock: gameClock,
        period: period,
        scores: [
          {
            teamId: homeTeam?.id,
            score: Number(homeScore),
          },
          {
            teamId: guestTeam?.id,
            score: Number(guestScore),
          },
        ],
      };

      const param: AV.IGameScoreParam = {
        gameScore: entity?.leagueGame,
        game: entity?.leagueGame,
        score: JSON.stringify(scorePayload),
        scoreType: entity?.scoreType,
      };

      const updatedLeagueGame = await AV.Game.addScore(param);
      console.log("Updated LeagueGame:", updatedLeagueGame);

      let index = entitydatalist?.findIndex(
        (x) => x?.id === updatedLeagueGame?.id,
      );
      if (index !== -1) {
        entitydatalist[index] = updatedLeagueGame;
        dispatch(setEntitydata(entitydatalist));
      }
      setLeagueGameEntity?.(updatedLeagueGame);
    } catch (err) {
      console.error("Failed to add score:", err);
    } finally {
      setIsRsvpLoading(false);
    }
  };

  const handleDeleteScore = async (id) => {
    try {
      setisLoad(true);
      setDeleteLoadingId(id);

      const score = leagueGameEntity?.scoreHistory?.find((x) => x.id === id);

      const param: AV.IGameScoreParam = {
        gameScore: entity?.leagueGame,
        game: entity?.leagueGame,
        score: JSON.stringify(score),
        scoreType: entity?.scoreType,
      };

      const updatedLeagueGame = await AV.Game.deleteScore(param);
      console.log("Updated LeagueGame:", updatedLeagueGame);

      let index = entitydatalist?.findIndex(
        (x) => x?.id === updatedLeagueGame?.id,
      );
      if (index !== -1) {
        entitydatalist[index] = updatedLeagueGame;
        dispatch(setEntitydata(entitydatalist));
      }
      setLeagueGameEntity?.(updatedLeagueGame);
    } catch (err) {
      console.error("Failed to delete score:", err);
    } finally {
      setisLoad(false);
      setDeleteLoadingId(null);
    }
  };

  useEffect(() => {
    const loadScore = async () => {
      const homeTeamScore =
        leagueGameEntity?.score?.scores?.find((x) => x?.teamId === homeTeam?.id)
          ?.score ?? 0;

      const guestTeamScore =
        leagueGameEntity?.score?.scores?.find(
          (x) => x?.teamId === guestTeam?.id,
        )?.score ?? 0;

      setHomeScore(homeTeamScore);
      setGuestScore(guestTeamScore);
      setPeriod(leagueGameEntity?.score?.period ?? "1st Period");

      const currentGameClock = leagueGameEntity?.score?.gameClock ?? "00:00";
      setGameClock(currentGameClock);
      const [mins, secs] = currentGameClock.split(":");
      setMinutes(Number(mins));
      setSeconds(Number(secs));

      const timeline =
        leagueGameEntity?.scoreHistory?.map((item, index) => {
          const homeTeamScore =
            item?.scores?.find((x) => x?.teamId === homeTeam?.id)?.score ?? 0;

          const guestTeamScore =
            item?.scores?.find((x) => x?.teamId === guestTeam?.id)?.score ?? 0;

          return {
            id: item?.id,
            time: item?.gameClock,
            period:
              periods.find((x) => x.value === item?.period)?.label ??
              item?.period,

            text: `${
              homeTeam?.title ?? homeTeam?.name ?? "Home Team"
            } ${homeTeamScore} - ${guestTeamScore} ${
              guestTeam?.title ?? guestTeam?.name ?? "Other Team"
            }`,
          };
        }) || [];

      setTimelineData(timeline);
    };

    loadScore();
  }, [leagueGameEntity, homeTeam, guestTeam]);

  useEffect(() => {
    setGameClock(`${formatTime(minutes)}:${formatTime(seconds)}`);
  }, [minutes, seconds]);

  const PeriodDropdown = (editAccess) => (
    <Box position="relative" ref={menuRef}>
      <Pressable
        px={5}
        py={2}
        bg="#EEEEEE"
        borderRadius="full"
        flexDirection="row"
        alignItems="center"
        minW="150px"
        justifyContent="space-between"
        isDisabled={!editAccess}
        onPress={() => setShowPeriodMenu((p) => !p)}
      >
        <Text fontSize="16px" color="coolGray.700">
          {periods.find((x) => x.value === period)?.label ?? period}
        </Text>

        <ArrowActiveIcon width="24" height="24" />
      </Pressable>

      {showPeriodMenu && (
        <VStack
          position="absolute"
          top="45px"
          left={0}
          bg="white"
          borderRadius="12px"
          shadow={4}
          zIndex={999}
          minW="150px"
          overflow="hidden"
        >
          {periods.map((p) => (
            <Pressable
              key={p.value}
              px={4}
              py={3}
              _hover={{
                bg: "coolGray.100",
              }}
              onPress={() => {
                setPeriod(p.value);
                setShowPeriodMenu(false);
              }}
            >
              <Text fontSize="16px">{p.label}</Text>
            </Pressable>
          ))}
        </VStack>
      )}
    </Box>
  );

  return (
    <Box w="100%" bg="#F5F4F1" py={0} px={0}>
      <VStack bg="white" px={2} py={2} space={4} w="100%" mx="auto">
        {/* HEADER */}
        <HStack justifyContent="space-between" alignItems="center">
          {/* SCORE / TIMELINE */}
          <HStack
            bg="#EEEEEE"
            borderRadius="full"
            p="2px"
            h="50px"
            alignItems="center"
          >
            <Pressable
              px={8}
              py={3}
              borderRadius="full"
              bg={activeTab === "score" ? "AVColor.primary" : "#EEEEEE"}
              onPress={() => setActiveTab("score")}
            >
              <Text
                fontWeight="500"
                fontSize="16px"
                color={activeTab === "score" ? "white" : "black"}
              >
                {Loc.currentLang.gameEvent.score}
              </Text>
            </Pressable>

            <Pressable
              px={8}
              py={3}
              borderRadius="full"
              bg={activeTab === "timeline" ? "AVColor.primary" : "#EEEEEE"}
              onPress={() => setActiveTab("timeline")}
            >
              <Text
                fontWeight="500"
                fontSize="16px"
                color={activeTab === "timeline" ? "white" : "black"}
              >
                {Loc.currentLang.gameEvent.timeline}
              </Text>
            </Pressable>

            {isGameEnded && (
              <Pressable
                px={8}
                py={3}
                borderRadius="full"
                bg={activeTab === "chat" ? "AVColor.primary" : "#EEEEEE"}
                onPress={() => setActiveTab("chat")}
              >
                <Text
                  fontWeight="500"
                  fontSize="16px"
                  color={activeTab === "chat" ? "white" : "black"}
                >
                  {Loc.currentLang.gameEvent.chat}
                </Text>
              </Pressable>
            )}
          </HStack>

          {/* PERIOD */}
          {activeTab === "score" && (
            <>
              {isAdminView && !isGameEnded ? (
                <PeriodDropdown editAccess={editAccess} />
              ) : (
                <HStack
                  alignItems="center"
                  bg="#EEEEEE"
                  px={6}
                  py={3}
                  borderRadius="full"
                  space={3}
                >
                  <Text fontSize="16px" fontWeight="400">
                    {periods.find((x) => x.value === period)?.label ?? period}
                  </Text>
                </HStack>
              )}
            </>
          )}
        </HStack>

        {/* SCORE BOARD */}
        {activeTab === "score" && (
          <>
            <HStack
              justifyContent="space-evenly"
              alignItems="center"
              zIndex="-3px"
            >
              {/* HOME */}
              <VStack
                flex={1}
                alignItems="center"
                space={isAdminView && !isGameEnded ? 2 : 1}
              >
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  color="#00000080"
                  letterSpacing="1px"
                >
                  {homeTeam?.title ?? homeTeam?.name ?? "Home Score"}
                </Text>

                {isAdminView && !isGameEnded ? (
                  <Input
                    value={String(homeScore).padStart(2, "0")}
                    onChangeText={(text) => {
                      const value = Number(text.replace(/[^0-9]/g, ""));
                      setHomeScore(isNaN(value) ? 0 : value);
                    }}
                    keyboardType="numeric"
                    maxLength={4}
                    textAlign="center"
                    variant="unstyled"
                    fontSize="50px"
                    fontWeight="500"
                    color="#08A9C7"
                    width="120px"
                    height="70px"
                    p={0}
                  />
                ) : (
                  <Text
                    fontSize="50px"
                    fontWeight="500"
                    color="#08A9C7"
                    lineHeight={"55px"}
                  >
                    {String(homeScore).padStart(2, "0")}
                  </Text>
                )}

                {isAdminView && !isGameEnded && (
                  <HStack space={3}>
                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="#EEEEEE"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={() => setHomeScore(Math.max(0, homeScore - 1))}
                    >
                      <MinusIcon size="30px" color="#2D2D2D" />
                    </Button>

                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="#EEEEEE"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={() => setHomeScore(homeScore + 1)}
                    >
                      <AddIcon size="26px" color="#32AE78" />
                    </Button>
                  </HStack>
                )}
              </VStack>

              {/* DIVIDER */}
              <Divider
                orientation="vertical"
                bg="#EEEEEE"
                thickness="1px"
                h={isAdminView && !isGameEnded ? "220px" : "120px"}
              />

              {/* CENTER */}
              <VStack
                flex={1}
                alignItems="center"
                space={isAdminView && !isGameEnded ? 2 : 1}
              >
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  color="#00000080"
                  letterSpacing="1px"
                >
                  {Loc.currentLang.gameEvent.gameClock}
                </Text>

                {isAdminView && !isGameEnded ? (
                  <Input
                    value={gameClock}
                    onChangeText={(text) => {
                      let cleaned = text.replace(/[^0-9:]/g, "");

                      if (cleaned.length === 2 && !cleaned.includes(":")) {
                        cleaned += ":";
                      }

                      setGameClock(cleaned);

                      const parts = cleaned.split(":");

                      const mins = Number(parts[0] || 0);
                      const secs = Number(parts[1] || 0);

                      setMinutes(mins);
                      setSeconds(secs > 59 ? 59 : secs);
                    }}
                    maxLength={5}
                    textAlign="center"
                    variant="unstyled"
                    fontSize="40px"
                    fontWeight="500"
                    color="#2D2D2D"
                    width="120px"
                    height="70px"
                    p={0}
                  />
                ) : (
                  <Text
                    fontSize="40px"
                    fontWeight="500"
                    color="#2D2D2D"
                    lineHeight={"55px"}
                  >
                    {gameClock}
                  </Text>
                )}

                {isAdminView && !isGameEnded && (
                  <HStack space={3}>
                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="#EEEEEE"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={decreaseTime}
                    >
                      <MinusIcon size="30px" color="#2D2D2D" />
                    </Button>

                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="#EEEEEE"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={increaseTime}
                    >
                      <AddIcon size="26px" color="#32AE78" />
                    </Button>
                  </HStack>
                )}
              </VStack>

              {/* DIVIDER */}
              <Divider
                orientation="vertical"
                bg="#EEEEEE"
                thickness="1px"
                h={isAdminView && !isGameEnded ? "220px" : "120px"}
              />

              {/* GUEST */}
              <VStack
                flex={1}
                alignItems="center"
                space={isAdminView && !isGameEnded ? 2 : 1}
              >
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  color="#00000080"
                  letterSpacing="1px"
                >
                  {guestTeam?.title ?? guestTeam?.name ?? "Guest Score"}
                </Text>

                {isAdminView && !isGameEnded ? (
                  <Input
                    value={String(guestScore).padStart(2, "0")}
                    onChangeText={(text) => {
                      const value = Number(text.replace(/[^0-9]/g, ""));
                      setGuestScore(isNaN(value) ? 0 : value);
                    }}
                    keyboardType="numeric"
                    maxLength={4}
                    textAlign="center"
                    variant="unstyled"
                    fontSize="50px"
                    fontWeight="500"
                    color="#08A9C7"
                    width="120px"
                    height="70px"
                    p={0}
                  />
                ) : (
                  <Text
                    fontSize="50px"
                    fontWeight="500"
                    color="#08A9C7"
                    lineHeight={"55px"}
                  >
                    {String(guestScore).padStart(2, "0")}
                  </Text>
                )}

                {isAdminView && !isGameEnded && (
                  <HStack space={3}>
                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="coolGray.200"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={() => setGuestScore(Math.max(0, guestScore - 1))}
                    >
                      <MinusIcon size="30px" color="#2D2D2D" />
                    </Button>

                    <Button
                      px={8}
                      py={2}
                      borderWidth={1}
                      borderColor="coolGray.200"
                      borderRadius="12px"
                      bg="white"
                      _hover={{ bg: "white" }}
                      _pressed={{ bg: "white" }}
                      isDisabled={!isGameStarted ? !editAccess : false}
                      onPress={() => setGuestScore(guestScore + 1)}
                    >
                      <AddIcon size="26px" color="#32AE78" />
                    </Button>
                  </HStack>
                )}
              </VStack>
            </HStack>

            {/* BUTTON */}
            {isAdminView && !isGameEnded && (
              <Button
                alignSelf="center"
                borderRadius="18px"
                w="275px"
                h="46px"
                bg="AVColor.primary"
                _hover={{ bg: "#289966" }}
                _pressed={{ bg: "#289966" }}
                isLoading={isRsvpLoading}
                isDisabled={
                  !isGameStarted ? isRsvpLoading || !editAccess : false
                }
                onPress={handleAddScore}
              >
                <Text
                  color="white"
                  fontSize="18px"
                  fontWeight="400"
                  letterSpacing="0.5px"
                >
                  {Loc.currentLang.gameEvent.publishScore}
                </Text>
              </Button>
            )}
          </>
        )}

        {/* TIMELINE */}
        {activeTab === "timeline" && (
          <Box
            pt={1}
            h={isAdminView && !isGameEnded ? "282px" : "120px"}
            maxH={isAdminView && !isGameEnded ? "282px" : "120px"}
          >
            <ScrollView showsVerticalScrollIndicator>
              {timelineData?.length === 0 ? (
                <Box py={6} alignItems="center">
                  <Text fontSize="13px" color="coolGray.400">
                    {Loc.currentLang.gameEvent.noScoreHistoryFound}
                  </Text>
                </Box>
              ) : (
                timelineData.map((item, index) => (
                  <HStack
                    key={item?.id}
                    alignItems="center"
                    py={3}
                    borderBottomWidth={1}
                    borderColor="coolGray.100"
                  >
                    {/* TIME */}
                    <Box width="80px">
                      <Text fontSize="16px" color="coolGray.600">
                        {item?.time}
                      </Text>
                    </Box>

                    {/* DETAILS */}
                    <HStack
                      flex={1}
                      px={3}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Text fontSize="16px" color="coolGray.800">
                        {item?.text}
                      </Text>

                      <HStack alignItems="center" space={4}>
                        <Text fontSize="16px" color="coolGray.500">
                          {item?.period}
                        </Text>

                        {isAdminView && !isGameEnded && (
                          <>
                            {isLoad && deleteLoadingId === String(item?.id) ? (
                              <Spinner size="sm" color="#08A9C7" />
                            ) : (
                              <Button
                                bg="white"
                                _hover={{ bg: "white" }}
                                _pressed={{ bg: "white" }}
                                isDisabled={
                                  !isGameStarted ? !editAccess : false
                                }
                                onPress={() => handleDeleteScore(item?.id)}
                              >
                                <CloseIcon size="18px" color="#E13D3C" />
                              </Button>
                            )}
                          </>
                        )}
                      </HStack>
                    </HStack>
                  </HStack>
                ))
              )}
            </ScrollView>
          </Box>
        )}

        {/* chat page*/}
        {activeTab === "chat" && (
          <AVChatMessage
            page={"header"}
            props={props}
            entity={entity}
            setEntity={setEntity}
            editAccess={editAccess}
            isAdminView={isAdminView}
            setIsAdminView={setIsAdminView}
            leagueGameEntity={leagueGameEntity}
            setLeagueGameEntity={setLeagueGameEntity}
            isEntireSeriesAvailable={isEntireSeriesAvailable}
          />
        )}
      </VStack>
    </Box>
  );
};

export default memo(ProfileHeader);
